/* =================================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ================================================================================= */
(function($) {

    const currentMetadataUserVersion = 3;


    var mgUtils = {
        


        // Google Tag Manager function send
        ga: function(category, action, label){

            if(typeof ga === 'function') {

                category = category ? category : '';
                action = action ? action : '';
                label = label ? label : '';

                ga('send', 'event', category, action, label);

            } else {
                console.error('ga is not a function');
            }

        },

        checkComparador: function() {
            var comparador = [];
            var comparadorCounter = 0;
            comparador = localStorage.getItem("comparador");
            //1. Tots els botons de comparador, els posem active.
            $.each( JSON.parse(comparador), function( key , value ) {
                //console.log(".mgComparador[data-id='"+value+"']");
                $(".mgComparador[data-id='"+value+"']").addClass("active");
                comparadorCounter++;
            });
            //2. Posem numero de cotxes comparats i mostrem missatge
            if(comparadorCounter>0){
                $(".mgComparadorCounter").html(comparadorCounter);
                $(".mgComparadorMessage").addClass("active");
                $(".mgComparadorMessage").closest(".menu-item").removeClass("hide");
            }else{
                $(".mgComparadorMessage").removeClass("active");
                $(".mgComparadorMessage").closest(".menu-item").addClass("hide");
            }
        },

        pushLocalStorage: function(item,data) {
            var a = [];
            if (localStorage[item]) {
                a = JSON.parse(localStorage.getItem(item));
            }
            a.push(data);
            localStorage.setItem(item, JSON.stringify(a));
            console.log(localStorage.getItem(item));
        },

        pullLocalStorage: function(item,data) {
            var a = [];
            if (localStorage[item]) {
                a = JSON.parse(localStorage.getItem(item));
            }
            a.remove(data);
            localStorage.setItem(item, JSON.stringify(a));
            console.log(localStorage.getItem(item));
        },

        iosCareBug : function(){

            var ua = navigator.userAgent,
            scrollTopPosition,
            iOS = /iPad|iPhone|iPod/.test(ua),
            iOS11 = /OS 11_0_1|OS 11_0_2|OS 11_0_3|OS 11_1|OS 11_1_1|OS 11_1_2|OS 11_2|OS 11_2_1/.test(ua);
            // ios 11 bug caret position
            if ( iOS && iOS11 ) {
                $(document.body).on('show.bs.modal', function(e) {
                    if ( $(e.target).hasClass('inputModal') ) {
                        // Get scroll position before moving top
                        scrollTopPosition = $(document).scrollTop();
                        // Add CSS to body "position: fixed"
                        $("body").addClass("iosBugFixCaret");
                    }
                });

                $(document.body).on('hide.bs.modal', function(e) {
                    if ( $(e.target).hasClass('inputModal') ) {         
                        // Remove CSS to body "position: fixed"
                        $("body").removeClass("iosBugFixCaret");

                        //Go back to initial position in document
                        $(document).scrollTop(scrollTopPosition);
                    }
                });
            }
                    
        },

        changeSpinner: function(){

            (function(doc,found) {
                window.addEventListener('DOMSubtreeModified', function() {

                var yourdiv = doc.querySelector(".gform_ajax_spinner");

                if(found && !yourdiv){
                    // Was there but is gone, do something
                    found = false;
                    //console.log("out");
                }

                if(yourdiv){
                    // Found it, do something
                    found = true;                      
                    if( $('#mediagach-loader').length > 0){

                    }else{
                    //console.log("inn");
                    $( '<div id="mediagach-loader" class="spinner-mediagach"><div id="container-arch"><div id="loader-arch"></div></div></div>' ).insertAfter( ".gform_ajax_spinner" );


                    }
                }

                }, false);
            })(document,false);           

        },

        changeWidgetTranslatorStyle: function(item,data) {

            $('#google_translate_element').on("click", function () {

                // Change font family and color
                $("iframe").contents().find(".goog-te-menu2-item div, .goog-te-menu2-item:link div, .goog-te-menu2-item:visited div, .goog-te-menu2-item:active div, .goog-te-menu2 *")
                    .css({
                        'color': '#000',                        
                    });
                // Change menu's padding
                /*$("iframe").contents().find('.goog-te-menu2-item-selected').css ('display', 'none');
                    
                // Change menu's padding
                $("iframe").contents().find('.goog-te-menu2').css ('padding', '0px');
              
                // Change the padding of the languages
                $("iframe").contents().find('.goog-te-menu2-item div').css('padding', '20px');
              
                // Change the width of the languages
                $("iframe").contents().find('.goog-te-menu2-item').css('width', '100%');
                $("iframe").contents().find('td').css('width', '200px');
                */
                // Change hover effects
                $("iframe").contents().find(".goog-te-menu2-item div").hover(function () {
                    $(this).css('background-color', '#000').find('span.text').css('color', 'white');
                }, function () {
                    $(this).css('background-color', 'white').find('span.text').css('color', '#000');
                });
                /*
                // Change Google's default blue border
                $("iframe").contents().find('.goog-te-menu2').css('border', 'none');
                */
                // Change the iframe's box shadow
                $(".goog-te-menu-frame").css('box-shadow', '0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.3)');
                /*
                // Change the iframe's size and position?
                $(".goog-te-menu-frame").css({
                    'height': '165px'
                    
                });

                // Change iframes's size
                $("iframe").contents().find('.goog-te-menu2').css({
                    'height': '100%',
                    'width': '200px'
                });
                */
            });
        },

        bounceRate60: function(item,data) {
            setTimeout(function(){
                mgUtils.ga('Tiempo en página de más de 30s', 'NoBounce');
                console.log("30s");
            },30000);
        },

        tracking: function(item,data) {
            mgUtils.bounceRate60();
            //Contacto INIT
            //Telefono desktop menu
            $("#menu-menu-lateral .telefonoHeader").on("click",function(){
                mgUtils.ga('Llamada','Contacto','Botón menú desktop');
            });
            //Telefono mobile menu
            $(".main-toggle-content .call").on("click",function(){
                mgUtils.ga('Llamada','Contacto','Botón menú mobile');
            });
            //GPS mobile menu
            $(".main-toggle-content .gps").on("click",function(){
                mgUtils.ga('GPS','Contacto','Botón menú desktop');
            });
            //Contacto END

            //tasacion desde oferta
            $(".claim-tasa a").on("click",function(){
                mgUtils.ga('Tasación','Clic desde oferta');
            });
            //Telefonos desplegable
            $(".ver-telefonos").on("click",function(){
                mgUtils.ga('Telefonos desplegable', 'Abrir');
            });

            $(".ver-telefonos .telf-header-container").on("click",function(){
                mgUtils.ga('Telefonos desplegable', this.getAttribute('name'));
            });

            //Oferta detalle
            $(".offer-detail-container-form").on("click",function(){
                mgUtils.ga('Oferta Detalle', 'Side Form');
            });

            $(".btn-open-form-detail").on("click",function(){
                mgUtils.ga('Oferta Detalle', 'Formulario popup');
            });

            $(".openPopup[data-target='#popupTeLlamamos']").on("click",function(){
                mgUtils.ga('Oferta Detalle', 'Te llamamos popup');
            });

            $(".tasamos").on("click",function(){
                mgUtils.ga('Oferta Detalle', 'Tasamos tu vehículo');
            });

            $(".openPopup.socialShare").on("click",function(){
                mgUtils.ga('Oferta Detalle', 'Comparte la oferta');
            });

            //Menus
            $(".mg-menu-horizontal a[title]").on("click",function(){
                mgUtils.ga('Menu principal', this.getAttribute('title'));
            });

            $("#menu-menu-lateral a[title]").on("click",function(){
                mgUtils.ga('Menu lateral', this.getAttribute('title'));
            });
        },

        initModuleOpiniones: function(item,data) {
            var owlOpiniones = $(".owl-carousel-opiniones");
            owlOpiniones.owlCarousel({
                loop:true,
                margin:10,
                nav:true,
                animateOut: 'slideOutDown',
                animateIn: 'flipInX',
                autoplay:true,
                autoplayTimeout:9000, 
                autoplayHoverPause:true, 
 
                responsive:{
                    0:{
                        items:1
                    },
                    600:{
                        items:2
                    },
                    1000:{
                        items:3
                    }
                }
            });

            owlOpiniones.find('.item').on('mouseenter',function(e){
            $(this).closest('.owl-carousel').trigger('stop.owl.autoplay');
            })
            owlOpiniones.find('.item').on('mouseleave',function(e){
            $(this).closest('.owl-carousel').trigger('play.owl.autoplay',[500]);
            })

            $(document).on('window_onload', function(){
                $(".blockBubble .opinion").sameheight();
            });

        },

        openPopup: function(item,data) {
            var trigger = $(this).attr("data-trigger");
            var title = $(this).attr("data-title");

            if(title){
                $($(this).attr("data-target")+" .modal-title").html(title);
            }    
            if(trigger){
                $(trigger).trigger("click");
            }
            $($(this).attr("data-target")).modal();
        },

        carousels: function(item,data) {
            //Carrussel mediagach
            var carousel = $(".carousel-mg"); 
            carousel.each(function() {
                items = $(this).attr("data-items") || "3";
                nav = ($(this).attr("data-nav") !== "false");
                autoplay = ($(this).attr("data-autoplay") !== "false");
                autoplayTimeout = $(this).attr("data-autoplayTimeout") || "5000";
                $(this).owlCarousel({
                    nav:nav,
                    loop:true,
                    margin:10,
                    autoplay: autoplay,
                    items: items,
                    autoplayTimeout: autoplayTimeout
                });

            });
        },

        

        

        randomTransitionDelay: function(element,delay,ordered) {
            //element: tipus d'element que volem aplicar-li delay
            //delay: temps que trigarà en acabar totes les animacions
            //ordered: true/false: per ordenar les animacions

            var n = element.length;
            var numDelays = delay/n;

            if(ordered){
                element.each(function( index ) {
                    var i=index+1;
                    $( this ).css("transitionDelay",numDelays*i+"s");
                });
            }else{
                element.each(function( index ) {
                    $( this ).css("transitionDelay",delay*Math.random()+"s");
                });
            }

        },

        getUrlParameter: function(nomParametre){
            var sPageURL = window.location.search.substring(1),
                    sURLVariables = sPageURL.split('&'),
                    sParameterName,
                    i;

                for (i = 0; i < sURLVariables.length; i++) {
                    sParameterName = sURLVariables[i].split('=');
                    if (sParameterName[0] === nomParametre) {
                        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                    }
                }
        },

        initMetadataStructure : function() {

            aux = {
                    utils: {   
                        ver: currentMetadataUserVersion,  
                        adw: {
                            id:  0,
                            id2: 0,
                            price: 0
                        },
                        se: [],
                        source: document.referrer,
                        idOferta: 0,
                        utm_source: utmSource,
                        utm_medium: utmMedium,
                        utm_campaign: utmCampaign
                    }
                };

            return aux;
        },  

        initMetaDataStorage: function(item,data) {
            
            var utm_source = this.getUrlParameter('utm_source');
            if(utm_source === undefined){
                utmSource = '';
            }else{
                utmSource = utm_source;
            }

            var utm_medium = this.getUrlParameter('utm_medium');
            if(utm_medium === undefined){
                utmMedium = '';
            }else{
                utmMedium = utm_medium;
            }

            var utm_campaign = this.getUrlParameter('utm_campaign');
            if(utm_campaign === undefined){
                utmCampaign = '';
            }else{
                utmCampaign = utm_campaign;
            }

            if(typeof(Storage) !== "undefined") {
                if (localStorage.getItem("metadataUser") === null) {
                    //console.log("no tenim la variable metadataUser");
                    metadataUsuari = this.initMetadataStructure(utmSource,utmMedium,utmCampaign); 
                }else{
                    metadataUsuari = JSON.parse(localStorage.getItem("metadataUser"));    
                    if(!metadataUsuari.hasOwnProperty('utils')){
                        localStorage.clear();
                        metadataUsuari = this.initMetadataStructure(utmSource,utmMedium,utmCampaign);
                    }else{
                        if(!metadataUsuari.utils.hasOwnProperty('ver')){
                            //no te la variable ver per tant netegem tota la variable de local
                            //console.log('no te la variable ver per tant netegem tota la variable de local');
                            localStorage.clear();
                            metadataUsuari = this.initMetadataStructure(utmSource,utmMedium,utmCampaign);
                        }else{
                            if(currentMetadataUserVersion === metadataUsuari.utils.ver){
                                //tenim la mateixa versió de metadata no cal borrar
                                //console.log('tenim la mateixa versió de metadata no cal borrar');

                                if(utmSource != ''){
                                    metadataUsuari['utils']['utm_source'] = utmSource;
                                }                    
                                if(utmMedium != ''){
                                    metadataUsuari['utils']['utm_medium'] = utmMedium;
                                }
                                if(utmCampaign != ''){
                                    metadataUsuari['utils']['utm_campaign'] = utmCampaign;
                                }    

                            }else{
                                //les versions de metadata no coincideixen, hem de netejar
                                //console.log('les versions de metadata no coincideixen, hem de netejar');
                                localStorage.clear();
                                metadataUsuari = this.initMetadataStructure(utmSource,utmMedium,utmCampaign);

                            }
                        }
                    }
                                          
                }
                
                localStorage.setItem("metadataUser", JSON.stringify(metadataUsuari));
                
                //$('.hidden_referrer input').attr('value', metadataUsuari.utils.source);

            }
           

        },

        trackMetaDataStorage: function(level0, level1, level2, level3, data, operation ) {

            /*                
                exemple posar valor normal
                mgUtils.trackMetaDataStorage('leadInfo', 'idOferta', '', '', 2432 );                
                mgUtils.trackMetaDataStorage('leadInfo', 'fb', 'estona', '', 36 );                
                mgUtils.trackMetaDataStorage('leadInfo', 'sessions', '1', 'estona', 23 );
                
                exemple posar estructura a un array -> s'ha d'especificar la paraula 'push'
                mgUtils.trackMetaDataStorage('leadInfo', 'sessions', '', '', { dataAcces: 0, estona: 0 }, 'push');

                exemple per modificar algun element de l'últim objecte d'un array -> es deixa la posició de l'array a ''
                mgUtils.trackMetaDataStorage('leadInfo', 'sessions', '', 'estona', 5555); 

            */
            
            //console.log("level:::"+level0+"---"+level1);
            metadataUsuari = JSON.parse(localStorage.getItem("metadataUser"));
                    
            if( level2 != '' ){
                if( level3 != '' ){
                    if(operation == 'push'){
                        if(metadataUsuari[level0][level1][level2][level3] == null){
                            var newElement = [];
                            newElement.push(data);
                            metadataUsuari[level0][level1][level2][level3] = newElement;
                        }else{
                            metadataUsuari[level0][level1][level2][level3].push(data);
                        }
                    }else{
                        metadataUsuari[level0][level1][level2][level3] = data;
                    }      
                }else{
                    if(operation == 'push'){
                        if(metadataUsuari[level0][level1][level2] == null){
                            var newElement = [];
                            newElement.push(data);
                            metadataUsuari[level0][level1][level2] = newElement;
                        }else{
                            metadataUsuari[level0][level1][level2].push(data);
                        }
                        
                    }else{
                        metadataUsuari[level0][level1][level2] = data;
                    }                    
                }

            }else{
                if( level3 != '' ){
                    metadataUsuari[level0][level1][metadataUsuari[level0][level1].length-1][level3] = data;
                }else{
                    if(operation == 'push'){
                        if(metadataUsuari[level0][level1] == null){
                            var newElement = [];
                            newElement.push(data);
                            metadataUsuari[level0][level1] = newElement;                            
                        }else{
                            metadataUsuari[level0][level1].push(data);
                        }
                        
                    }else{
                        metadataUsuari[level0][level1] = data;
                    }
                }
            }

            localStorage.setItem("metadataUser", JSON.stringify(metadataUsuari));
            
           
        },

        saveTrackStorageToLead: function(item) {

            if(typeof(Storage) !== "undefined") {
                if (typeof localStorage['metadataUser'] === null) {
                                                                          
                }else{                      
                    //leadInfo = JSON.stringify(localStorage.getItem("metadataUser"));
                    metadataUsuari = localStorage.getItem("metadataUser");
                    $(item).html(metadataUsuari);                         
                }
            } 


        }, 


        googleAdwordsCodes: function(item,data) {
                       
            if($(".adw-content").length != 0){
                metaDataUsuari = JSON.parse(localStorage.getItem("metadataUser"));                 
                aux=metadataUsuari['utils']['adw'];                 
                if(aux == null) {
                    
                    adw = { 
                            id:  $(".adw-content").attr("data-adw-item"),
                            id2: $(".adw-content").attr("data-adw-item2"),
                            price: $(".adw-content").attr("data-adw-totalvalue")
                        };
                    metaDataUsuari.utils['adw'] = adw;                    
                    localStorage.setItem("metadataUser", JSON.stringify(metaDataUsuari));
                }else{
                    

                    if(metaDataUsuari['utils']['adw']['id'] == null){
                        metaDataUsuari.utils['adw']['id'] = $(".adw-content").attr("data-adw-item");
                        localStorage.setItem("metadataUser", JSON.stringify(metaDataUsuari));
                    }else{
                        mgUtils.trackMetaDataStorage('utils', 'adw', 'id', '',  $(".adw-content").attr("data-adw-item"));
                    }

                    if(metaDataUsuari['utils']['adw']['id2'] == null){
                        metaDataUsuari.utils['adw']['id2'] = $(".adw-content").attr("data-adw-item2");
                        localStorage.setItem("metadataUser", JSON.stringify(metaDataUsuari));
                    }else{
                        mgUtils.trackMetaDataStorage('utils', 'adw', 'id2', '',  $(".adw-content").attr("data-adw-item2")); 
                    }

                    if(metaDataUsuari['utils']['adw']['price'] == null){
                        metaDataUsuari.utils['adw']['price'] = $(".adw-content").attr("data-adw-totalvalue");
                        localStorage.setItem("metadataUser", JSON.stringify(metaDataUsuari));
                    }else{
                       mgUtils.trackMetaDataStorage('utils', 'adw', 'price', '',  $(".adw-content").attr("data-adw-totalvalue"));
                    }
                                       
                    
                }                   
            }

        },

        formSubmitSetMetadataUser: function(e) {

            e.preventDefault();
            mgUtils.googleAdwordsCodes();
            
            //obtenim el id de formulari
            idButton = $(this).attr("id");
            aux = idButton.split("_");
            idForm = "#"+aux[0]+"_"+aux[(aux.length-1)];

            
            mgUtils.saveTrackStorageToLead(idForm+' .hidden_data_usr textarea');

            $(idForm).submit();
            

        },

        unaAltraGenericafUNC: function(item,data) {
            console.log(localStorage.getItem(item));
            //.......
        },

        metadataUser: function() {
            /// METADATA 
// User Sessions 
var hoy = new Date();
hoy = hoy.getDate() + '-' + (hoy.getMonth() + 1) + '-' + hoy.getFullYear();

var sessions = {};

var session = {
    date: hoy,
    du: 0,
    lo: 0 
}


if(typeof(Storage) !== "undefined") {
    if (localStorage.getItem("metadataUser") === null) {


    }else{
        
        metadataUsuari = JSON.parse(localStorage.getItem("metadataUser"));

        if(metadataUsuari.utils.se.length == 0){
            //se=[] encara no té valors dins

            mgUtils.trackMetaDataStorage('utils', 'se', '', '', session , 'push');
            mgUtils.trackMetaDataStorage('utils', 'se', '', 'lo', ++session.lo);
        }else{

            var last = metadataUsuari.utils.se[metadataUsuari.utils.se.length - 1];

            if(last.date != hoy) {
                //els dies són diferents creem nova posicio a l'array de sessions
                mgUtils.trackMetaDataStorage('utils', 'se', '', '', session , 'push');
                mgUtils.trackMetaDataStorage('utils', 'se', '', 'lo', ++session.lo);
            }else{
                //seguim en el mateix dia afegim un load més a l'última sessió
                mgUtils.trackMetaDataStorage('utils', 'se', '', 'lo', ++last.lo);
            } 
        }

        var sessionTime = Date.now();

        document.body.addEventListener('click', function() {
            var resta = Date.now() - sessionTime;
            session.du += resta <= 900000 ? resta : 0;  // 900.000 = 15min
            mgUtils.trackMetaDataStorage('utils', 'se', '', 'du', session.du); 
            sessionTime = Date.now();
        });

        if(!metadataUsuari.utils.hasOwnProperty('ci')){
            //si no té la variable ci llavors anem a omplir
            //console.log('entro a localitzar-me');
            $.ajax({
                url: 'https://ip-to-geolocation.com/api/json?key=96b7a5a329382c3c5194820c627393a6', 
                success: function(result) {
                    mgUtils.trackMetaDataStorage('utils', 'ci', '', '', encodeWord(result.city)); 
                    mgUtils.trackMetaDataStorage('utils', 're', '', '', encodeWord(result.regionName)); 
                    mgUtils.trackMetaDataStorage('utils', 'co', '', '', encodeWord(result.country)); 
                }
            });
        }else{
            //console.log('ja estic localitzat');            
        }

    }

}


function encodeWord(str){
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
        return String.fromCharCode('0x' + p1);
    }));
}


/*
if(JSON.parse(localStorage.getItem('metadataUser')).leadInfo != undefined) {
    sessions = JSON.parse(localStorage.getItem('metadataUser')).leadInfo.sessions;
    var last = sessions[sessions.length - 1];
    // x
    if(last == undefined || last.date != hoy) {
        mgUtils.trackMetaDataStorage('leadInfo', 'sessions', '', '', session , 'push');
    } else {
        session = last;
    }

    mgUtils.trackMetaDataStorage('leadInfo', 'sessions', '', 'loads', ++session.loads);

    //Time
    var sessionTime = Date.now();

    document.body.addEventListener('click', function() {
        var resta = Date.now() - sessionTime;
        session.estona += resta <= 900000 ? resta : 0;  // 900.000 = 15min
        mgUtils.trackMetaDataStorage('leadInfo', 'sessions', '', 'estona', session.estona); 
        sessionTime = Date.now();
    })
    // Country, Region, City
    var leadInfo = JSON.parse(localStorage.getItem('metadataUser')).leadInfo;

    if(leadInfo['city'] == undefined || leadInfo['country'] == undefined || leadInfo['region'] == undefined) {
        $.ajax({
            url: 'https://ip-to-geolocation.com/api/json?key=96b7a5a329382c3c5194820c627393a6', 
            success: function(result) {
                mgUtils.trackMetaDataStorage('leadInfo', 'city', '', '', result.city); 
                mgUtils.trackMetaDataStorage('leadInfo', 'region', '', '', result.regionName); 
                mgUtils.trackMetaDataStorage('leadInfo', 'country', '', '', result.country); 
            }
        });
    }
    
} else {
    localStorage.removeItem('metadataUser');
}
*/


//////////////
        },
        //Capitalize the first letter
        capitalize: function(str) {
            if(typeof(str) === 'string') {
                return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase(); 
            } 
            return str;
        },

        // classList.replace polyfill (ie)
        replaceClass: function(el, a, b) {
       
            if(el) {
                var clases = el.getAttribute('class').split(' ');
        
                for(var x = 0; x < clases.length; x++) {
                    if(clases[x] == a) clases[x] = b;
                }
        
                clases = clases.join(' ');
        
                el.setAttribute('class', clases);
        
            }
        }

    };

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function() {
                // JavaScript to be fired on all pages
                mgUtils.initMetaDataStorage();
            },
            finalize: function() {
                
                /// POLYFILL
                // Polyfill for Array.findIndex
// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
if (!Array.prototype.findIndex) {
    Object.defineProperty(Array.prototype, 'findIndex', {
    value: function(predicate) {
    // 1. Let O be ? ToObject(this value).
        if (this == null) {
        throw new TypeError('"this" is null or not defined');
        }

        var o = Object(this);

        // 2. Let len be ? ToLength(? Get(O, "length")).
        var len = o.length >>> 0;

        // 3. If IsCallable(predicate) is false, throw a TypeError exception.
        if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
        }

        // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
        var thisArg = arguments[1];

        // 5. Let k be 0.
        var k = 0;

        // 6. Repeat, while k < len
        while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return k.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
            return k;
        }
        // e. Increase k by 1.
        k++;
        }

        // 7. Return -1.
        return -1;
    },
    configurable: true,
    writable: true
    });
}

//Math.trunc polyfill for ie
Math.trunc = Math.trunc || function(x) {
    if (isNaN(x)) {
        return NaN;
    }
    if (x > 0) {
        return Math.floor(x);
    }
    return Math.ceil(x);
};

//Includes polyfill for ie
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';
    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}

function getNavigatorName() {
  if((!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0) {
    return 'opera';
  }
  if(typeof InstallTrigger !== 'undefined') {
    return 'firefox';
  }
  if(/constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification))) {
    return 'safari';
  }
  if(false || !!document.documentMode) {
    return 'ie';
  }
  if(!!window.StyleMedia) {
    return 'edge';
  }
  if(!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)) {
    return 'chrome';
  }
  return 'otherNavigator';
}


// from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('remove')) {
      return;
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        if (this.parentNode !== null)
          this.parentNode.removeChild(this);
      }
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);;
                //////////////

                /// TOPBAR CTA 
                
/// Key Messages v2.0.1

$.ajax({
    url: mediagach_vars.rootFolder + '/wp-content/themes/mediagach/templates/modules/get-key-messages.php', 
    success: function(result) {
        result = JSON.parse(result);
    
        setSessionStorage(result);
        if (window.location.search.indexOf('webview') === -1) {
            buildTopbar(result.topbar);
        }
        buildAlert(result.alert);
        buildToast(result.toast);
        buildInter(result.inter);

    }
}); 

function setSessionStorage(result) { 
    if(sessionStorage.getItem('closeCta') != null) return true; 

    var setObj = {
        topbars: {},
        alerts: {},
        toasts: {}
    };

    result.topbar.forEach(function(tb) {
        setObj['topbars'][tb.id] = true;
    })

    result.alert.forEach(function(al) {
        setObj['alerts'][al.id] = true;
    })

    result.toast.forEach(function(tt) {
        setObj['toasts'][tt.id] = true;
    })

    sessionStorage.setItem('closeCta', JSON.stringify(setObj));
}

// Inter Offers
function buildInter(its){
    var metaData = JSON.parse(localStorage.getItem('metadataUser'));
    var parent = document.querySelector('.row-ofertas');

    var size = window.innerWidth;
    var colSizes = [
        size <= 767,
        size <= 991 && size > 767,
        size < 1200 && size > 991,
        size >= 1200
    ]; 

    var currentSize = colSizes.findIndex(function(x) { return x;});

    if(parent && its.length > 0) {
   
        function insertInters() {

            //Determina la posicio on ha d'anar el banner segons el size de la pagina
            function setPosition(offer, fila) {
                var colData = offer.getAttribute('class').split(' ');
                var tamanys = [];
    
                colData.forEach(function(c, i) {
    
                    var arr1 = colData[i].split('-');
    
                    if(arr1[0] == 'col' && arr1.length == 3) {
                        rowSize = 12 / parseInt(arr1[2]);
                        tamanys.push(rowSize);
                    }
    
                })
    
                return fila * tamanys[currentSize];
            }
    
            its.forEach(function(x, i) {
    
                var already = document.querySelector('#inter-' + x.id);
    
                var filters = [
                    valUrl(x),
                    excUrl(x),
                    valSLoads(x, metaData),
                    valCountry(x, metaData),
                    valRegion(x, metaData),
                    valCity(x, metaData)
                ];
    
                if(!already && filters.every(valid)) {
                    var offers = document.querySelectorAll('.oferta-item');
                    var inter = document.createElement('div');  

                    if(offers.length > 0) {
                        var position = setPosition(offers[0], x.fila);
        
                        inter.setAttribute('class','col-xs-12 col-sm-12 col-md-12 col-lg-12 km-inter');
                        inter.setAttribute('id','inter-' + x.id);
                        inter.style.backgroundImage = 'linear-gradient(to right,' + x.bg_1 + ',' + x.bg_2 + ')';
                        inter.style.color = x.color;
                        inter.innerHTML = x.html;
        
                        if(offers[position]) {
                            parent.insertBefore(inter, offers[position]);
    
                            inter.addEventListener('click', function(){
                                mgUtils.ga('Ofertas','KeyMessages Inter', 'Fila: ' + position);
                            });
                        }
                    }

                }
               
            });
    
        }

        // Apaño
        var offers = document.querySelectorAll('.oferta-item');
        if(offers[0]) {
            insertInters();
        }
        //////
    
        //Event procedent de listOffers ajax
        $(document).on('insert_inter', function() {
            insertInters();
        });
    
        window.addEventListener('resize', function() {
            var kmInters = document.querySelectorAll('.km-inter');
            size = window.innerWidth;
            colSizes = [
                size <= 767,
                size <= 991 && size > 767,
                size < 1200 && size > 991,
                size >= 1200
            ]; 

            kmInters = Array.prototype.slice.call(kmInters,0); 
    
            kmInters.forEach(function(x) { 
                x.remove(); 
            })
    
            currentSize = colSizes.findIndex(function(x) { return x;});
            insertInters();
        })
    }
}

// TOPBAR
function buildTopbar(tbs) {

    var html = '';
    var metaData = JSON.parse(localStorage.getItem('metadataUser'));
    var topbars = JSON.parse(sessionStorage.getItem('closeCta')).topbars;

    tbs.forEach(function (tb) {
        //Aplicar filtres: tancat, validar, excluir, sloads, country, region, city
        var filters = [
            topbars[tb.id],
            valUrl(tb),
            excUrl(tb),
            valSLoads(tb, metaData),
            valCountry(tb, metaData),
            valRegion(tb, metaData),
            valCity(tb, metaData)
        ];

        if(filters.every(valid)) setHtml(tb);
    })

    if(html.length > 0) {
        var divAux = document.createElement('div'); // Evitar bug amb menu ofertas
        document.body.appendChild(divAux); // Evitar bug amb menu ofertas
    
        divAux.innerHTML += html;

        topbarCta();
    }

    function setHtml(tb) { 
        html += '<div topbar-id="' + tb.id + '" class="container-fluid topbarCtaBar" style="color: ' + tb['color'] + ';background-image: linear-gradient(to right,' + tb['bg_1'] + ',' + tb['bg_2'] + ');">';
        html +=   '<div class="row">';
        html +=       '<div class="col-xs-1 col-sm-2 col-md-2 col-lg-2"></div>';
        html +=       '<div class="col-xs-9 col-sm-8 col-md-8 col-lg-8 vCenter">' + tb['html'] +'</div>';
        html +=       '<div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 closeCta"><i class="fa fa-times" aria-hidden="true"></i></div>';      
        html +=   '</div>';
        html += '</div>';
    }     
}

function topbarCta() {
    var allCta = document.querySelectorAll('.topbarCtaBar');
    var mtBody = parseInt(window.getComputedStyle(document.body).getPropertyValue('margin-top'));
    var ctaFxs = document.querySelectorAll('.fixedNavKM'); //Busca els fixed 
    var animInt;

    allCta = Array.prototype.slice.call(allCta,0); //ie
    ctaFxs = Array.prototype.slice.call(ctaFxs,0); //ie

    // Guardar el margin original dels fixed
    for(var x in ctaFxs) {
        if(typeof(ctaFxs[x]) === 'object') {
            var fixMargin = parseInt(window.getComputedStyle(ctaFxs[x]).getPropertyValue('margin-top'));
            if(typeof(ctaFxs[x]) === 'object') ctaFxs[x].setAttribute('ctaMargin', fixMargin);
        }
    }

    getMaxHeight(allCta); // Estableix el height en base al topbar mes gran
    animInt = animOpacity0(allCta); // Animacio Fade per veure tots els topbars
    marginFixeds(allCta, mtBody, ctaFxs); // Mou tots els elements Fixeds respecte als topbar
    closeAllCtaX(allCta, mtBody, ctaFxs, animInt); // Tanca tots els ctas de cop
    resizeTopbar(allCta, mtBody, ctaFxs); // Ajusta tots els elements segons el height necesari
}

function getMaxHeight(allCta) {
    maxH = 0; 

    allCta.forEach(function(cta) {
        var ctaHeight = parseInt(window.getComputedStyle(cta).height);
        if(ctaHeight > maxH) maxH = ctaHeight;
    })

    allCta.forEach(function(cta) {
        var ctaHeight = parseInt(window.getComputedStyle(cta).height);
        if(ctaHeight != maxH) { 
            cta.style.height = maxH + 'px';
        } else {
            cta.classList.add('maxH');
            var close = cta.childNodes[0].children[2];
            close.setAttribute('style', 'height: ' + maxH + 'px'); // z.style.height no funciona
        }
    })
}

function animOpacity0(allCta) { 
    var clock = allCta.lenght == 1 ? 0 : 1;
    var animInt = '';
    if(allCta.length > 1) {
        allCta[0].style.zIndex = 9999;
        animInt = setInterval(function() {
            allCta.forEach(function(cta, index) {
                if(index == clock) {
                    cta.style.transition = '0s';
                    cta.style.opacity = 1;
                    setTimeout(function() {
                        cta.style.zIndex = 9998;
                    }, 300)
                } else {
                    cta.style.transition = '.3s';
                    cta.style.opacity = 0;
                    setTimeout(function() {
                        cta.style.zIndex = 9997;
                    }, 300)
                } 
            })
            clock = clock < allCta.length - 1 ? ++clock : 0;
        }, 5000)
    }

    return animInt;
}

function marginFixeds(allCta, mtBody, ctaFxs) {
    var ctaHeight = parseInt(window.getComputedStyle(allCta[0]).height);  

    document.body.style.marginTop = (mtBody + ctaHeight) + 'px';  

    for(var x in ctaFxs) {
        if(typeof(ctaFxs[x]) === 'object') {
            var fixMargin = parseInt(ctaFxs[x].getAttribute('ctaMargin'));
            ctaFxs[x].style.marginTop = (fixMargin + ctaHeight) + 'px'; 
        }
    }
}

function closeAllCtaX(allCta, mtBody, ctaFxs, animInt) {
    var s = JSON.parse(sessionStorage.getItem('closeCta'));
    allCta.forEach(function(cta) {

        var close = cta.childNodes[0].children[2];

        close.addEventListener('click', function() {

            clearInterval(animInt);

            allCta.forEach(function(cta) {
                var ctaHeight = parseInt(window.getComputedStyle(cta).height);
                cta.style.height = ctaHeight + 'px';
                cta.style.transition = '.3s';
        
                var tId = cta.getAttribute('topbar-id');
                s.topbars[tId] = false;
                
                setTimeout(function() {
                    cta.style.height = '0px';

                    document.body.style.marginTop = mtBody + 'px'; //Margin top inicial del Body

                    ctaFxs.forEach(function(x) {
                        var fixMargin = parseInt(window.getComputedStyle(x).marginTop);
                        x.style.transition = '.3s';
                        x.style.marginTop = (fixMargin - ctaHeight) + 'px';
                    }) 

                }, 10);
            })

            sessionStorage.setItem('closeCta', JSON.stringify(s));

        })
        
    })
}

function resizeTopbar(allCta, mtBody, ctaFxs) {
    window.addEventListener('resize', function() {
        var ctaMax = document.querySelector('.maxH');
        var maxH = parseInt(window.getComputedStyle(ctaMax).height);

        allCta.forEach(function(cta) {
            if (cta != ctaMax) cta.style.height = maxH + 'px';
        })   

        marginFixeds(allCta, mtBody, ctaFxs);
    })
}
////////////

// Alert
function buildAlert(als) {

    var html = '';
    var alerts = JSON.parse(sessionStorage.getItem('closeCta')).alerts;
    var metaData = JSON.parse(localStorage.getItem('metadataUser'));

    als.forEach(function (al) {

        if(alerts == null) {
            setObj[al.id] = true;
        } else {

            //Aplicar filtres: tancat, validar, excluir, sloads, country, region, city
            var filters = [
                alerts[al.id],
                excUrl(al),
                valUrl(al),
                valSLoads(al, metaData),
                valCountry(al, metaData),
                valRegion(al, metaData),
                valCity(al, metaData)
            ];

            if(filters.every(valid)) setHtml(al);  
        }

    })

    var headerCta = document.querySelector('.alert-here') == null ? 'header' : '.alert-here';

    if(document.querySelector(headerCta) != null) {
        if(html.length != 0) {
            html = '<div class="alerts-container">' + html + '</div>';
            document.querySelector(headerCta).innerHTML += html;  
            alertCta(); 
        }
    } 

    function setHtml(al) {
        html +=  '<div alert-id="' + al.id +'" class="alertCta" style="color:' + al['color'] + '; background-image: linear-gradient(to right,' + al['bg_1'] + ',' + al['bg_2'] + '); box-shadow: inset 0 0 0 2px ' + al['color'] + '">';
        html +=    '<div class="msg">' + al['html'] + '</div>';
        html +=    '<div class="closeAlert"><i class="fa fa-times" aria-hidden="true"></i></div>';
        html +=  '</div>';
    }
}

function alertCta() { 
    var alerts = document.querySelectorAll('.alertCta');
    var s = JSON.parse(sessionStorage.getItem('closeCta'));

    alerts.forEach(function(alert) {
        var close = alert.childNodes[1];
        close.addEventListener('click', function() {
            alert.style.opacity = 0;
            setTimeout(function() {
                alert.style.margin = 0;
                alert.style.height = 0;
                alert.style.minHeight = 0;
                alert.style.border = 0;
                alert.style.fontSize = 0;
                close.style.display = 'none';
            }, 500);

            var aId = alert.getAttribute('alert-id');

            s.alerts[aId] = false;
            sessionStorage.setItem('closeCta', JSON.stringify(s));
        })
    })
}
////////////

// Toast
function buildToast(tts) {
    var metaData = JSON.parse(localStorage.getItem('metadataUser'));
    var sObj = JSON.parse(sessionStorage.getItem('closeCta'));

    tts.forEach(function(tt) {

        var fTime = false;
        tt.time = parseInt(tt.time);
        tt.delay = parseInt(tt.delay);
        if(isNaN(tt.time)) tt.time = 0;
        if(isNaN(tt.delay)) tt.delay = 0;

        if(tt.options != '') {
            fTime = tt.options.find(function(e) {return e == "firstTime"}) == undefined ? false : true;
        }

        toastr.options = {
            "closeButton": true,
            "debug": false,
            "newestOnTop": false,
            "progressBar": true,
            "positionClass": 'toast-top-right',
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": tt.time * 1000,
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        }

        //Aplicar filtres: tancat, validar, excluir, sloads, country, region, city
        var filters = [
            sObj.toasts[tt.id],
            valUrl(tt),
            excUrl(tt),
            valSLoads(tt, metaData),
            valCountry(tt, metaData),
            valRegion(tt, metaData),
            valCity(tt, metaData)
        ];

        setTimeout(function() {
            if(filters.every(valid)) {
                toastr['info'](tt.html);
                var toastList = document.querySelector('#toast-container');
                var lastToast = toastList.children[toastList.children.length - 1];
                lastToast.style.backgroundColor = tt.bg_1;
                lastToast.style.color = tt.color;
            }
        }, tt.delay * 1000);
 
        if(fTime) {
            sObj.toasts[tt.id] = false;
            sessionStorage.setItem('closeCta', JSON.stringify(sObj));
        }
    })
}
///////////

// Validacions de filtres 
function valUrl(x) {
    var show = x.show.replace(/ /g,'').replace(/,/g,'|');

    if(/\*/.test(show)) {
        return true;
    } else {
        var reg = new RegExp(show);
        return reg.test(window.location.href);
    }
}

function excUrl(x) {
    var hide = x.hide.replace(/ /g,'').replace(/,/g,'|');
    if(x.hide.length == 0) return true; // ?

    if(/\*/.test(hide)) {
        return false;
    } else {
        var reg = new RegExp(hide);
        return !reg.test(window.location.href);
    }
}

function valSLoads(x, m) {
    if(x.s_loads == null || x.s_loads <= 1) return true;

    var sessions = m.utils.se;

    if(sessions.length == 0){
        var last = {
            date: hoy,
            du: 0,
            lo: 0
        };
    }else{
        var last = sessions[sessions.length - 1];
    }

    return last.lo >= x.s_loads;
}

function valCountry(x, m) {
    if(x.country == undefined || x.country.length == 0) return true;

    var country = atob(m.utils.co);

    return x.country.includes(country); 
}

function valRegion(x, m) {
    if(x.region == undefined || x.region.length == 0) return true;

    var region = atob(m.utils.re);

    return x.region.includes(region); 
}

function valCity(x, m) {
    if(x.city == undefined || x.city.length == 0) return true;

    var city = atob(m.utils.ci);
   
    return x.city.includes(city); 
}

function valid(e) {
    return e;
};
                //////////////

                /// VER TELEFONOS
                var verTelf = document.querySelectorAll('.ver-telefonos');
var desplegables = document.querySelectorAll('.ver-telefonos .desplegable');


document.body.addEventListener('click', function(ev) {

    if(!(ev.target.getAttribute('class') == 'ver-telefonos') && !(ev.target.getAttribute('class') == 'ver-text')) {
        for(var x = 0; x < desplegables.length; x++) {
            desplegables[x].style.height = 0 ;
        }
    }

});


for(var x = 0; x < verTelf.length; x++) {

    verTelf[x].addEventListener('click', function() {
        var desplegable = this.children[this.children.length - 1];
        var els = desplegable.children.length;

        var current = window.getComputedStyle(desplegable).height;

        if(parseInt(current) == 0) {
            desplegable.style.height = (els * 70) + 'px';
        } else {
            desplegable.style.height = 0;
        }

    })

    var desplegable = verTelf[x].children[verTelf[x].children.length - 1];

    desplegable.addEventListener('mouseleave', function() {
        this.style.height = '0px';
    })
}

;
                //////////////

                // JavaScript to be fired on all pages, after page specific JS is fired
                // Form Design Module
                function formDesign() {

    var inputs = document.querySelectorAll('.gform_wrapper input[type="text"]');
    var textareas = document.querySelectorAll('.gform_wrapper textarea');
    var selects = document.querySelectorAll('.gform_wrapper .ginput_container_select');

    buildFields(inputs, 'inp');
    buildFields(textareas, 'txta');


    selects = Array.prototype.slice.call(selects,0); 
    selects.forEach(function(el) {
        el.previousSibling.classList.add('select-label');
    });

}

function buildFields(els, type) {
    els = Array.prototype.slice.call(els,0); 
    els.forEach(function (el) {
        var label = el.parentNode.previousSibling;
    
        if(label && label.nodeName == 'LABEL') {
    
            el.classList.add('fd-' + type);
            label.classList.add('fd-labels-' + type);
    
            el.addEventListener('focus', function() {

                mgUtils.replaceClass(label, 'fd-labels-' + type, 'fd-labels-' + type + '-out');
                mgUtils.replaceClass(el, 'fd-' + type, 'fd-' + type + '-out');
    
            });
    
            el.addEventListener('focusout', function() {
    
                if(el.value.length == 0) {
                    mgUtils.replaceClass(label, 'fd-labels-' + type + '-out', 'fd-labels-' + type);
                    mgUtils.replaceClass(el, 'fd-' + type + '-out', 'fd-' + type);
                }
            
            });
    
        }
    });

}

 

                formDesign(); 

                //ksa lang selector
                var ksaSelected = document.querySelector('.ksa-option-selected');
                var ksaOptions  = document.querySelector('.ksa-options-lang');

                if(ksaSelected) {
                    ksaSelected.addEventListener('click', function() {
                        ksaOptions.style.display = 'block';
                    });
    
                    document.body.addEventListener('click', function(ev) {
                        if(ev.target.getAttribute('ksaLang') == null) {
                            ksaOptions.style.display = 'none';
                        } 
                    });
                }

                //ksa buscador
                var ksaBuscador = document.querySelector('#ksaBuscador');
                var enVenta = document.querySelector('#enVenta');
                var enAlquiler = document.querySelector('#enAlquiler');
                //var enTraspaso = document.querySelector('#enTraspaso');
                var selectOperacio = '';


                if(ksaBuscador){

                    enVenta.addEventListener('click', function(){
                        if(enVenta.classList.contains('active')){
                            enVenta.classList.remove('active');
                            selectOperacio = '';
                        } else {
                            enVenta.classList.add('active');
                            enAlquiler.classList.remove('active');
                            //enTraspaso.classList.remove('active');

                            selectOperacio = '&operacio='+$(this).attr("data-name").toLowerCase();
                        }
                    })
    
                    enAlquiler.addEventListener('click', function(){
                        if(enAlquiler.classList.contains('active')){
                            enAlquiler.classList.remove('active');
                            selectOperacio = '';
                        } else {
                            enVenta.classList.remove('active');
                            enAlquiler.classList.add('active');
                            //enTraspaso.classList.remove('active');
                            selectOperacio = '&operacio='+$(this).attr("data-name").toLowerCase();
                            //selectOperacio = '&operacio=en%20alquiler';
                        }
                    })
    
                    /*enTraspaso.addEventListener('click', function(){
                        if(enTraspaso.classList.contains('active')){
                            enTraspaso.classList.remove('active');
                            selectOperacio = '';
                        } else {
                            enVenta.classList.remove('active');
                            enAlquiler.classList.remove('active');
                            enTraspaso.classList.add('active');

                            selectOperacio = '&operacio=en%20traspaso';
                        }
                    })*/

                    //KSA BUSCADOR SELECTS
                    var defaults = document.querySelectorAll('.default');
                    var bOptions = document.querySelectorAll('.options');

                    defaults = Array.prototype.slice.call(defaults); // HTMLColletion to Array
                    bOptions = Array.prototype.slice.call(bOptions); // HTMLColletion to Array     

                    // Select: toggle displays
                    document.body.addEventListener('click', function(ev) {
                        if(ev.target.getAttribute('keep') == null) {
                            for(var x = 0; x < defaults.length; x++) {
                                defaults[x].nextElementSibling.style.display = 'none'; //.options
                            }
                        } 
                        if(ev.target.classList.contains('option')){
                            var value = ev.target.getAttribute('value');
                            var defaultDiv =  ev.target.parentNode.parentNode.children[0];
                            defaultDiv.setAttribute('value', value);
                            defaultDiv.innerHTML = ' <p keep="true">' + value + '</p>';
                            
                        }
                    });

                    for(var x = 0; x < defaults.length; x++) {
                        defaults[x].addEventListener('click', function() {

                            //Toggle Display block && none
                            var display = this.nextElementSibling.style.display; //.options
                            display = display == 'none' ? 'block' : 'none';

                            if(display == 'block') { 
                                var options = document.querySelectorAll('.options');
                                for(var i = 0; i < options.length; i++) options[i].style.display = 'none';
                            }
                            this.nextElementSibling.style.display = display;
                        });
                    }

                    ksaBuscador.addEventListener('click', function() {
                        var selectTipus = document.querySelector('#buscador-tipus .default').getAttribute('value');
                        //var selectMunicipi = document.querySelector('#buscador-municipi .default').getAttribute('value');

                        //selectMunicipi = selectMunicipi == '' ? '' : '&municipi=' + selectMunicipi;
                        selectTipus = selectTipus == '' ? '' : '&immoble=' + selectTipus;

                        if(mediagach_vars.currentLang = 'es') {
                            window.location.href = webUrl + 'cartera/?' + selectTipus + selectOperacio;
                        } else {
                            window.location.href = webUrl + 'ca/cartera/?' + selectTipus + selectOperacio;
                        }
                    });
                }

                // Form Design Module - Te llamamos asyncForm 
                $('#asyncformdesign').on('click', function() {
                    formDesign();
                });

                // Form Design Module - Gravity Froms amb paginació 
                $(document).on('gform_page_loaded', function() {
                    formDesign();
                });
                
                rootFolder = webUrl;

                // MG STYLES
                
// Centros

var centros = document.body.className;

if(/cd1/.test(centros)) {

    var centroItems = document.querySelectorAll('.centro-item');

    for(var i = 0; i < centroItems.length; i++) {
        mgUtils.replaceClass(centroItems[i].parentNode, 'col-md-3', 'col-md-4');
        mgUtils.replaceClass(centroItems[i].parentNode, 'col-lg-3', 'col-lg-4');
    }

    var horariosBtn = document.querySelector('.topInfo a[href="#horarios"]');
    var telefonoBtn = document.querySelector('.topInfo a[href^="tel:+34"]');
    var formularioBtn = document.querySelector('.topInfo a[href="#formulario"]');

    //Borrem
    if(horariosBtn) horariosBtn.parentNode.remove();
    if(formularioBtn) formularioBtn.parentNode.remove();
    if(telefonoBtn) telefonoBtn.parentNode.remove();

    // Intercanvi 1 

    var topInfo = document.querySelector('.topInfo');
    if(topInfo) {
        var imageDiv = topInfo.nextElementSibling;
        imageDiv.parentNode.insertBefore(imageDiv, topInfo);
    }

    // Intercanvi 2 

    var mapa = document.querySelector('.mapa');

    if(mapa) {
        mapa = mapa.parentNode;
        var horariosDiv = mapa.nextElementSibling;

        horariosDiv.parentNode.insertBefore(horariosDiv, mapa);
        mapa.appendChild(topInfo);
    
        mapa.style.marginBottom = '50px';
        topInfo.style.paddingTop = '30px';
        topInfo.style.width = '100%';
        horariosDiv.style.marginTop = '50px';
    }

    // Servicios fora

    var servicios = document.querySelector('#servicios');

    if(servicios) servicios.parentNode.remove();


}


if(/cd2/.test(centros)) {
    var centroItems = document.querySelectorAll('.centro-item');

    for(var i = 0; i < centroItems.length; i++) {
        mgUtils.replaceClass(centroItems[i].parentNode, 'col-md-3', 'col-md-4');
        mgUtils.replaceClass(centroItems[i].parentNode, 'col-lg-3', 'col-lg-4');
    }
}
// Formularis

;
                //////////////
                
                function onScrollInit( items, trigger ) {

                    items.each( function() {
                        var osElement = $(this); 
                        var osAnimationDelay;      
                        
                        if( typeof osElement.attr('data-mg-animation-delay') === 'undefined') {                            
                            osAnimationDelay = '0s';                           
                        }else{
                            osAnimationDelay = osElement.attr('data-mg-animation-delay');
                        }

                        osElement.css({
                            '-webkit-animation-delay':  osAnimationDelay,
                            '-moz-animation-delay':     osAnimationDelay,
                            'animation-delay':          osAnimationDelay
                        });

                        var animationTypeElement;

                        if( typeof osElement.attr('data-mg-animation') === 'undefined') {                            
                            animationTypeElement = 'fadeIn';                           
                        }else{
                            animationTypeElement = osElement.attr('data-mg-animation');
                        }

                        var osTrigger = ( trigger ) ? trigger : osElement;

                        osTrigger.waypoint(function() {
                            osElement.addClass('animated').addClass(animationTypeElement);
                        },{
                            triggerOnce: true,
                            offset: '90%'
                        });
                    });

                }

                onScrollInit( $('.mg-animation') );


                function setCookieTrue(){
                    $("#cookie-bar").removeClass("active");
                    localStorage.cookies=Date.now();
                } 

                function checkCookies(){
                    if(localStorage.cookies==null){
                        $("#cookie-bar").addClass("active");
                        /*TODO: Si hace scroll>200px. Si la cookie es superior a 3 meses.*/
                        
                        /*Despues de 15 segundos*/
                        setTimeout(function(){ 
                            setCookieTrue();
                        }, 10000);
                        
                        /*Si acepta cookies*/
                        $("#acceptCookies").on("click",function(){
                            setCookieTrue();
                        });

                    }
                }

                Array.prototype.remove = function() {
                    var what, a = arguments, L = a.length, ax;
                    while (L && this.length) {
                        what = a[--L];
                        while ((ax = this.indexOf(what)) !== -1) {
                            this.splice(ax, 1);
                        }
                    }
                    return this;
                };

                $(document).ready(function() {

                    checkCookies();
                    mgUtils.checkComparador();
                    mgUtils.iosCareBug();
                    mgUtils.changeSpinner();
                    mgUtils.changeWidgetTranslatorStyle();
                    mgUtils.tracking();
                    //mgUtils.initMetaDataStorage();
                    mgUtils.randomTransitionDelay($(".modal .social-block"),0.6,false);                    
                    mgUtils.metadataUser();

                    //Carrussel mediagach
                    var owls = $('.carousel-mg'); 
                    owls.each(function() {

                        var autoplay = ($(this).attr('data-autoplay') !== 'false');
                        var items = $(this).attr('data-items') || '3';
                        var dots = ($(this).attr('data-dots') !== 'false');
                        var nav = ($(this).attr('data-nav') !== 'false');

                        $(this).owlCarousel({
                            nav: nav,
                            loop: true,
                            margin: 10,
                            autoplay: autoplay,
                            dots: dots,
                            items: items,
                            navText: [
                                "<i class='icon-mediagach-navigation-chevron-left'></i>",
                                "<i class='icon-mediagach-navigation-chevron-right'></i>"
                            ],
                        });

                    });

                    $(".openPopup").on("click",mgUtils.openPopup);

                    $("body").on("click",'button[type="submit"], input[type="submit"]', mgUtils.formSubmitSetMetadataUser);


                    //Listener listOffers
                    $(document).on("insert_inter", function(){
                        $(".openPopup").on("click",mgUtils.openPopup);
                    })

                    /*Sertisa excepció*/
                    $("[title='te llamamos trigger']").on("click",function(){
                        $(".openPopup[data-target='#popupTeLlamamos']").trigger("click");
                    });

                    //$("body").on("click",'input[type="submit"]',mgUtils.googleAdwordsCodes);


                    if ( $( ".opinionesModule" ).length ) {
                        mgUtils.initModuleOpiniones();
                    }

                    $(".close-cookie").on("click",function(){
                        $("#cookie-bar").css("display","none");

                    });

                    /*carrega formulari als 1 segons*/
                    setTimeout(function(){ 
                        $('#popupTeLlamamos .btnAsyncTeLlamamos').trigger("click"); 
                    }, 1000);


                    
                    $(document).on('window_onload', function(){
                        $(".claim-block").sameheight();
                    });

                    /*var sticky = new Waypoint.Sticky({
                      element: $('nav.navbar-sticky')[0]
                    });*/
                    function manageMenu(){
                        $('#container-mobile-menu,button.navbar-toggle').toggleClass('is-active');
                        $("body").toggleClass("dontScroll");
                        $("#container-mobile-menu .categories").css("max-height",$(window).outerHeight()+"px");

                    }

                    $("#menu-menu-lateral .dropdown").on("click",function(){
                      var mg_helper = $(this).closest(".mg-side-menu-container").find(".mg-menu-helper");
                      if(!$(this).hasClass("open")){
                        mg_helper.empty();
                        $(this).find(".dropdown-menu").clone().appendTo( mg_helper );
                        mg_helper.addClass("open");
                      }else{
                        $(this).closest(".mg-side-menu-container").find(".mg-menu-helper").removeClass("open").empty();
                      }
                    });

                    $('.navbar-toggle,.l-menu .btn_close').on('click',manageMenu);


                    $( ".mg-menu-horizontal > ul > li" ).each(function( index ) {
                      if(!$(this).hasClass("hiddenMobile")){
                        $( this ).clone().appendTo( ".mainListMobile" );
                      }
                    });
                    $( ".mg-side-menu-container > div > ul > li" ).each(function( index ) {
                      if(!$(this).hasClass("hiddenMobile")){
                        $( this ).clone().appendTo( ".mainListMobile" );
                      }
                    });

                

                    /*FIX: Quan es clica a dropdown amb mobile, no funciona link*/
                    $('.dropdown-toggle').click(function(e) {
                      e.preventDefault();
                      setTimeout($.proxy(function() {
                        if ('ontouchstart' in document.documentElement) {

                          $(this).siblings('.dropdown-backdrop').off().remove();
                        }
                      }, this), 0);
                    });

                    //FICHAS CENTRO FOOTER INIT
                    var owlFichas = $('.owl-carousel-fichas');
                    owlFichas.owlCarousel({
                            items:6,
                            loop:false,
                            margin:0,
                            autoplay:false,
                            autoplayTimeout:5000,
                            autoplayHoverPause:false,
                            lazyLoad: true,
                            animateOut: 'fadeOut',
                            animateIn: 'fadeIn',
                            transitionStyle: "fade",

                            responsiveClass:true,
                                responsive:{
                                    0:{
                                        items:2,
                                    },
                                    1200:{
                                        items:3, 
                                    },
                                    1000:{
                                        items:4,
                                    }
                                }

                    });
                    //END FICHAS CENTRO FOOTER

                    //COMPARADOR INIT
                    //Funció que cridarem cada vegada que carreguem ofertes i hi hagi botó de COMPARAR.
                    $("body").on("click",".mgComparador",function(){
                        $(".effectIconComparador").remove();
                        var t = $(this);
                        var id = t.attr("data-id");
                        if(t.hasClass("active")){
                            t.removeClass("active");
                            mgUtils.pullLocalStorage("comparador",id);
                            mgUtils.checkComparador();
                        }else{
                            t.addClass("active");
                            mgUtils.pushLocalStorage("comparador",id);
                            mgUtils.checkComparador();

                            $("body").append('<i class="fa fa-heart effectIconComparador" aria-hidden="true"></i>');
                            var pos1= t.find('.fa-heart').offset();
                            var pos2 = $(".mgComparadorMessage .mgComparadorCounter").offset();

                            //Si menu lateral està a l'esquerra s'ha de fer:  pos1.left - XXXX;
                            var lateralWidth = 0;
                            if($('.mg-side-menu-container').css('display') !== 'none'){
                                lateralWidth = $(".mg-menu-vertical-left").width();
                            }

                            $(".effectIconComparador").css("left", pos1.left - lateralWidth);
                            $(".effectIconComparador").css("top", pos1.top);                             
                            $(".effectIconComparador").velocity({
                                    left: pos2.left+"px",
                                    top: pos2.top+"px",
                                    opacity: 0
                            }, {
                                    duration: 400, 
                                    easing: "easeInOutBack",
                            });   

                        }
                    });
                    $("body").on("click",".mgComparadorLink",function(e){
                        e.preventDefault();
                        var t = $(this);
                        var items = localStorage.getItem("comparador");
                        items = JSON.parse(items).join("-");
                        window.open(t.attr('href')+"?vehiculos="+items,"_self");
                    });

                    $('.offer-images').owlCarousel({
                        items: 1,
                        //autoplay: true,
                        dots: false,
                        nav: true, 
                        loop: true,
                        mouseDrag: false,
                        touchDrag: false,
                        pullDrag: false,
                        rewind: false,
                        lazyLoad: true,
                        transitionStyle : 'fade',
                        navText: [
                            '<object><a href="#" onclick="return false;"><i class="icon-mediagach-navigation-chevron-left"></i></a></object>',
                            '<object><a href="#" onclick="return false;"><i class="icon-mediagach-navigation-chevron-right"></i></a></object>'
                        ]
                    });

                    // 'AJAX' IMAGES
                    $('.offer-images').on('mouseover', function(ev) {

                        if(!this.getAttribute('hovered')) {

                            var owlItems = this.children[0].children[0].children; // owl-item
                            owlItems = Array.prototype.slice.call(owlItems); // HTMLColletion to Array
               
                            owlItems.forEach(function(element) {
                                var item = element.children[0]; //item
                                var urlImg = item.getAttribute('url-image');
                            
                                if(urlImg) item.setAttribute('style','background-image: url(' + urlImg + ')');
                            })

                            this.setAttribute('hovered', true);
                        }

                    });

                    $('.immoble3-carousel').owlCarousel({
                        items: 3,
                        autoplay: true,
                        dots: false,
                        nav: true, 
                        loop: true,
                        mouseDrag: true,
                        touchDrag: true,
                        autoplayHoverPause: true,
                        pullDrag: false,
                        rewind: false,
                        lazyLoad: true,
                        transitionStyle : 'fade',
                        navText: [
                            '<object><a href="#" onclick="return false;"><i class="icon-mediagach-navigation-chevron-left"></i></a></object>',
                            '<object><a href="#" onclick="return false;"><i class="icon-mediagach-navigation-chevron-right"></i></a></object>'
                        ],
                        responsive:{
                            0:{
                                items:1
                            },
                            600:{
                                items:2
                            },
                            1100:{
                                items:3
                            }
                        }        
                    });

                    //KSA OWL CAROUSEL 

                    $('.ksa-slider').owlCarousel({
                        items: 1,
                        autoplay: true,
                        dots: false,
                        nav: false, 
                        loop: true,
                        mouseDrag: false,
                        touchDrag: false,
                        pullDrag: false,
                        rewind: false,
                        lazyLoad: true,
                        animateOut: 'fadeOut',
                        navText: [
                            '<object><a href="#" onclick="return false;"><i class="icon-mediagach-navigation-chevron-left"></i></a></object>',
                            '<object><a href="#" onclick="return false;"><i class="icon-mediagach-navigation-chevron-right"></i></a></object>'
                        ]
                    });

                });


            
                $('img.lazy').on('load', function () {
                    Waypoint.refreshAll();
                });

                
                
setTimeout(function() {

    $('body').on('click','.mgComparador', function() {
        metaCount(this, 'numComparador');
    });

    $('body').on('click','.detallesBtn', function() {

        var visitesPon = document.querySelector('.row-ofertas').children;
        var currentDiv = this.parentNode.parentNode;
        var posicion = 0;

        for(var x = 0; x < visitesPon.length; x++) {

            if(visitesPon[x].children[0].isEqualNode(currentDiv)) {
                posicion = x;
            }

        }

        metaCount(this, 'numVisites', posicion);

    });

    $('body').on('click','.metaCountImageUrl', function() {
        metaCount(this, 'numVisites');
    });

    $('body').on('click','.socialShareMini, .socialShare', function() {
        metaCount(this, 'numLikes');
    });


}, 10000)


function metaCount(el, type, pon) {

    var idOferta = el.getAttribute('data-id');

    pon = pon == undefined ? '' : '&pon=' + pon;
    
    if(idOferta && type) {

        $.ajax({
            url: mediagach_vars.rootFolder + '/wp-content/themes/mediagach/utils/modules/count-fields.php/?idOffer=' + idOferta + '&type=' + type + pon,
        }); 

    }
} 


                //iPhone 5S Te llamamos

                if(window.innerWidth < 350) {
                    var s5 = document.querySelector('.teLlamamosHeader');
                    if(s5) s5.childNodes[0].textContent = '';
                }
                //Preloader
                window.onload = function() { 
                 
                    var preloader = document.querySelector('#mg_preloader');
                   
                    preloader.style.opacity = 0; 
                    setTimeout(function() {
                        preloader.style.display = 'none';
                    }, 300);


                    var waBtn = document.querySelector('#whatsapp-btn');

                    if(waBtn) {
                        waBtn.addEventListener('click', function(){
                            mgUtils.ga('Whatsapp');
                        })
                    }   

                    $("#container-mobile-menu a[title]").on("click",function(){
                        mgUtils.ga('Menu principal mobile', this.getAttribute('title'));
                    });

                    $(document).trigger('window_onload');
                    
                }

            }
        },
        // Blog page 
        'blog': {
            init: function() {
            },
            finalize: function() {
                $(document).on('window_onload', function(){
                    $('.blockPost').sameheight();
                });

            }
        },        // Home page 
        'home': {
            init: function() {
                // JavaScript to be fired on the home page
            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function() {
                // JavaScript to be fired on the about us page
            }
        },
        'page_template_template_contenido_formulario': {
            init: function() {
               
            },
            finalize: function() {

                var contenidoFormulario = document.querySelector('.contenido-formulario');
                var computedHeight = window.getComputedStyle(contenidoFormulario).height;

                contenidoFormulario.style.minHeight = computedHeight;

                $("body").on("click",".btn-open-form-detail",function(){
                    $("#modal-contenido-formulario").modal();
                });   

                switchForm();

                window.addEventListener('resize', function() {
                    switchForm();
                });

                function switchForm(){
                    var formWrapper   = document.querySelector('#formulario-wrapper');
                    var modalFormArea = document.querySelector('.modal-form-area');
                    var sideForm      = document.querySelector('.offer-detail-container-form');
                    
                    if(window.innerWidth < 993) {
                        modalFormArea.appendChild(formWrapper);
                    } else {
                        sideForm.appendChild(formWrapper);
                    }
                }

                /*new Waypoint({
                  element: $(".offer-detail-container-form"),
                  handler: function(direction) {
                    if(direction === "down"){
                        $(".offer-detail-container-form").addClass("stuck");
                    }else{
                        $(".offer-detail-container-form").removeClass("stuck");

                    }
                  },
                  offset: 27
                })*/

            }
        },
        'page_template_template_details_offer3':{
            init: function() {
                $('.current-slide-number').html('1');
            },
            finalize: function() {

                var sync1 = $("#carouselBig");
                var sync2 = $("#carouselSmall");
                var moduleCarousel = document.querySelector('.carouselBlock');
                var mc = {};

                if(moduleCarousel) {
                    var keys = Object.keys(moduleCarousel.parentNode.attributes); //Object.values no suportat per IE 11
                    var moduleCarousel = moduleCarousel.parentNode.attributes;

                    keys.forEach(function(x, i) { 
                        mc[moduleCarousel[x].nodeName] = moduleCarousel[x].nodeValue; 
                    });

                }
    
                // window onload envia event common preloader
                $(document).on('window_onload', function(){
                
                    sync1
                        .on('initialized.owl.carousel', function (el) {
                            $(".carouselCounter .numCounter").html("1");
                            var count = el.item.count-1;
                            $(".carouselCounter .numTotal").html(count+1);

                        })
                        .owlCarousel({
                            items : 1,
                            slideSpeed : mc['data-slideSpeed'] || 2000,
                            nav: true,
                            autoplay: mc['data-autoplay'] || false,
                            dots: mc['data-dots'] || false,
                            loop: mc['data-loop'] || true,
                            lazyLoad:true,
                            responsiveRefreshRate : 200,
                            animateOut: 'fadeOut',
                            navText: [
                                "<i class='icon-mediagach-navigation-chevron-left'></i>",
                                "<i class='icon-mediagach-navigation-chevron-right'></i>"
                                ],
                        }).on('changed.owl.carousel', syncPosition);


                    sync2
                        .on('initialized.owl.carousel', function () {
                        sync2.find(".owl-item").eq(0).addClass("current");
                        })
                        .owlCarousel({
                        items : mc['data-slidesperpage'] || 8,
                        dots: false,
                        nav: false,
                        smartSpeed: 200,
                        lazyLoad:true,
                        margin:1,
                        slideSpeed : 500,
                        slideBy: mc['data-slidesperpage'] || 8, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
                        responsiveRefreshRate : 100,
                        responsive: {
                            0: {
                                items: 4
                            }, 
                            576: {
                                items : mc['data-slidesperpage'] || 8
                            }
                        }
                    }).on('changed.owl.carousel', syncPosition2);
                });


                function syncPosition(el) {

                    var count = el.item.count-1;
                    var current = Math.round(el.item.index - (el.item.count/2) - .5);

                    if(current < 0) {
                        current = count;
                    }

                    if(current > count) {
                        current = 0;
                    }

                    $(".carouselCounter .numCounter").html(current+1);
                    $(".carouselCounter .numTotal").html(count+1);

                    sync2
                        .find(".owl-item")
                        .removeClass("current")
                        .eq(current)
                        .addClass("current");

                    var onscreen = sync2.find('.owl-item.active').length - 1;
                    var start = sync2.find('.owl-item.active').first().index();
                    var end = sync2.find('.owl-item.active').last().index();

                    if (current > end) {
                        sync2.data('owl.carousel').to(current, 100, true);
                    }else if (current < start) {
                        sync2.data('owl.carousel').to(current - onscreen, 100, true);
                    }

                }
  
                function syncPosition2(el) {
                    /*if(syncedSecondary) {
                    var number = el.item.index;
                    sync1.data('owl.carousel').to(number, 100, true);
                    }*/
                }
          
                $(document).on('window_onload', function(){
                    $(".grid-value").sameheight();


                    imageAspectRatio( $('.'+mediagach_vars.css+' #carouselBig').width(),  $('.'+mediagach_vars.css+' #carouselBig .item') );

                    
                    /*
                    var amplada = $('.marco #carouselBig').width();
                    if(amplada != null){
                        $('.marco #carouselBig .item').height((amplada*0.75));
                        
                        //console.log("amplada::"+amplada+"----"+(amplada*0.75));
                    }*/


                });

                $( window ).on( "resize", function(){

                    imageAspectRatio( $('.'+mediagach_vars.css+' #carouselBig').width(),  $('.'+mediagach_vars.css+' #carouselBig .item') );
                } );

                /*
                    var amplada = $('.marco #carouselBig').width();
                    if(amplada != null){
                        $('.marco #carouselBig .item').height((amplada*0.75));
                        
                        //console.log("amplada::"+amplada+"----"+(amplada*0.75));
                    } 
                } );
                */
          
                sync2.on("click", ".owl-item", function(e){
                    e.preventDefault();
                    var number = $(this).index();
                    sync1.data('owl.carousel').to(number, 300, true);
                });

                $("body").on("click",".btn-open-form-detail",function(){
                    mgUtils.trackMetaDataStorage('utils', 'idOferta', '', '', $('.adw-content').attr('data-id-item'));
                    copiedModal = $("#modal-pideOferta");
                    $("#modal-pideOferta").remove();
                    copiedModal.appendTo("body");
                    $("#modal-pideOferta").modal();
                    fillTextarea($(this));
                    fillHiddenField($(this));
                    $(".textarea-interested").addClass("hidden");
                    $(".addMessage p").removeClass("hidden");
                });

                $('#detailCarouselImages').on('slid.bs.carousel', function() {               
                    currentIndex = $('#detailCarouselImages div.active').index() + 1;
                    $('#detailCarouselImages .current-slide-number').html(''+currentIndex+'');

                });

                var formOffset = document.querySelector('.side-form');
                formOffset = formOffset ? formOffset.getAttribute('data-offset') : 27;

                /*var waypointBlockForm = new Waypoint({
                  element: $(".offer-detail-container-form"),
                  handler: function(direction) {
                    if(direction === "down"){
                        $(".offer-detail-container-form").addClass("stuck");
                    }else{
                        $(".offer-detail-container-form").removeClass("stuck");

                    }
                  },
                  offset: -685
                })*/

                function fillTextarea(t) {
                    $(".modal-offer-related textarea").html($(".detail-form-container textarea").html());
                }

                function fillHiddenField(t) {             
                    $(".modal-offer-related .textarea-privado textarea").html($(".detail-form-container .textarea-privado textarea").html());
                }

                texto = "Hola,\n\nMe gustaría recibir más información de:\n";
                texto = texto + "\t·" + $('.detail-model').text() + " - "+ $(".detail-final-price").text() +"\n";
                if ($(".vip-price-container").length > 0){
                    texto = texto + "Con promoción: " + $(".vip-price-container").text()+"\n";     
                }
                texto = texto + "\n¡Gracias!";

                $(".detail-form-container textarea").html(texto);

                textoHidden = $(".detail-model").attr("data-hidden");
                $(".detail-form-container .textarea-privado textarea").html(textoHidden);

                $(document).ready(function() {

                    $(".gform_button").on("click",function(){
                        ga('send', 'event', 'Enviar', $(this).attr("data-info"), '');
                    });

                    $(".btn-ver-fotos").on("click", function(){

                        indexItem = $('#detailCarouselImages .item.active').index();

                        var id = parseInt(indexItem);
                        heightMax = $( window ).height()*0.8;
                        //$('#modalGalleryPhotos .item img').height(heightMax);

                        copiedModal = $("#modalGalleryPhotos");
                        $("#modalGalleryPhotos").remove();
                        copiedModal.appendTo("body");                        

                        $('#modalGalleryPhotos .item img').css('max-height', heightMax+'px');
                        $('#modalGalleryPhotos').modal('show');
                        $('#modalCarousel').carousel(id);

                    });    

                    $("body").on("click",".addMessage",function(){
                         $(".textarea-interested").toggleClass("hidden");
                         $(".addMessage p").toggleClass("hidden");
                    });
                    
                    mgUtils.trackMetaDataStorage('utils', 'idOferta', '', '', $('.adw-content').attr('data-id-item'));
                    
                });

                $('#detailCarouselImages .item').on('load', function() {
            
                }).each(function(i) {
                    urlImatge = $(this).attr("data-photo"); 
                    
                    var item = $('<div class="item"><img class="img img-responsive" src="'+urlImatge+'" ></img></div>'); 
                    //var item = $('<div class="item" style=" background-image: url('+urlImatge+');"></div>');
                    item.appendTo('#modalGalleryPhotos .carousel-inner'); 
                    if (i==0){ // set first item active
                     item.addClass('active');
                    }
                  
                });          
                
                $(window).on('resize', function() {   
                    heightMax = $( window ).height()*0.8;
                    //$('#modalGalleryPhotos .item img').height(heightMax);
                   
                    $('#modalGalleryPhotos .item img').css('max-height', heightMax+'px');
                });
                
                $("#modalGalleryPhotos .carousel-inner").on("click", function(){
                    $('#modalGalleryPhotos').modal('toggle');
                });

            }

        },
        'page_template_template_gracias': {
            init: function() {
               
            },
            finalize: function() {

                $(document).ready(function() {
                    //console.log('entro');
                    if(typeof(Storage) !== "undefined") {
                        //console.log('entro2');
                        if (typeof localStorage['metadataUser'] === 'undefined') {   

                        }else{ 
                            //console.log('entro3'); 
                            metaUsuari = JSON.parse(localStorage.getItem("metadataUser"));   
                            //console.log(metaUsuari);
                            if((JSON.stringify(metaUsuari.utils.adw) === '{}')||(!metaUsuari.utils.adw)){
                                
                            }else{
                                var dataLayer = window.dataLayer || [];
                                dataLayer.push(
                                    {
                                        'dynx_pagetype' : 'conversion',
                                        'dynx_itemid': metaUsuari.utils.adw.id,
                                        'dynx_itemid2': metaUsuari.utils.adw.id2,
                                        'dynx_totalvalue' : metaUsuari.utils.adw.price 
                                    }); 
                                metaUsuari.utils.adw = {};
                                localStorage.setItem("metadataUser", JSON.stringify(metaUsuari));
                                //console.log(dataLayer);
                                
                            }                             
                            //console.log('conversion adwords');    
                        }
                    }
                });
            }
        },
        //OFERTAS MGMASTER css-> _ofertas5.scss && _moduleStyles.scss
        'page_template_template_ofertas5': {
            init: function() {

            },
            finalize: function(){
                
                //Per afegir un nou filtre s'ha de tocar: initListeners(), initFilters(), processData() || hardcoded(), new var
                var ofertasLlistat = document.querySelector('#ofertasLlistat .row-ofertas');
                var btnBorrar = document.querySelector('#borrarFiltres');
                var startFilter = 0;
                var limitFilter = 9;
                var infoFilters = {}; // Data de la taula ofertas
                var domFilters = domFilters(); // HTML dels filtres
                var urlFilters = {}; // Info de la url
                var filters = {}; // Objecte que es pasará a listOffers - AJAX
                var listOffersURL =  mediagach_vars.rootFolder + 'mediagach/scripts/listOffers2.php'; 
                var infoFilterURL =  mediagach_vars.rootFolder + 'mediagach/scripts/loadInfoForFilters.php';

                //customListOffers2 prove de client.js
                if(typeof(customListOffers2) !== 'undefined' && customListOffers2) {
                    listOffersURL = mediagach_vars.rootFolder + 'wp-content/themes/mediagach/clients/' +  mediagach_vars.cl + '/php/listOffers2.php';
                }

                function listOffers(){
                    $.ajax({
                        url: listOffersURL,
                        type: 'POST',
                        dataType: 'html',
                        data: { 'p' : mediagach_vars, 'start' : parseInt(startFilter), 'limit' : parseInt(limitFilter), 'filters' : filters},
                        success: function(data) {
                        
                            $("#ofertasLlistat .row-ofertas").append(data);

                            //Google Tag Manager
                            $(".ofertasBtn.verMas").on("click",function(){
                                mgUtils.ga('Ofertas','ver mas');
                            });

                            $(".ofertasBtn.pideOferta").on("click",function(){
                                mgUtils.ga('Ofertas','pide oferta popup');
                            });
                            
                            $(".link-to-detail").on("click",function(){
                                mgUtils.ga('Ofertas','Ficha click a oferta detalle');
                            });  
                            ///


                            mgUtils.checkComparador();

                            Waypoint.refreshAll();
                            

                            $('.offer-images').owlCarousel({
                                items: 1,
                                //autoplay: true,
                                dots: false,
                                nav: true, 
                                loop: true,
                                mouseDrag: false,
                                touchDrag: false,
                                pullDrag: false,
                                rewind: false,
                                lazyLoad: true,
                                transitionStyle : 'fade',
                                navText: [
                                    '<object><a href="#" onclick="return false;"><i class="icon-mediagach-navigation-chevron-left"></i></a></object>',
                                    '<object><a href="#" onclick="return false;"><i class="icon-mediagach-navigation-chevron-right"></i></a></object>'
                                ]
                            });

                            // 'AJAX' IMAGES
                            $('.offer-images').on('mouseover', function(ev) {

                                if(!this.getAttribute('hovered')) {

                                    var owlItems = this.children[0].children[0].children; // owl-item
                                    owlItems = Array.prototype.slice.call(owlItems); // HTMLColletion to Array
                       
                                    owlItems.forEach(function(element) {
                                        var item = element.children[0]; //item
                                        var urlImg = item.getAttribute('url-image');
                                    
                                        if(urlImg) item.setAttribute('style','background-image: url(' + urlImg + ')');
                                    })
    
                                    this.setAttribute('hovered', true);
                                }

                            });

                            //Num Ofertas
                            /*var numOffers = document.querySelector('#numOffers');
                            var numOffersDiv = document.querySelector('.numVehiculos');
                            
                            numOffers = numOffers ? numOffers.textContent : 0;
                            var s = numOffers == 1 ? '' : 's';

                            numOffersDiv.innerHTML = '<span>' + numOffers + '</span> ' + mediagach_vars.lang.inmueble + s; */
                            var numOffers = document.querySelector('#numOffers');
                            numOffers = numOffers ? numOffers.textContent : 0;

                            //Stock msg / row masker
                            /*console.log('longitud'+data.length);
                            console.log('totals'+numOffers);
                            console.log(numOffers);*/
                            if(data.length < 300 || numOffers == 0){
                                //console.log('entro1');
                                if($('.oferta-item').length === 0){
                                    $(".avisoNoStock").show();   
                                    //console.log('entro2');   
                                }else{                                    
                                    $(".avisoNoStock").hide(); 
                                    //console.log('entro3');                                   
                                }                                
                                $("#row-masker").hide();   
                                //console.log('entro4');                             
                            }else{
                                $(".avisoNoStock").hide();
                                if(numOffers>9){
                                    $("#row-masker").show();  
                                }
                                //console.log('entro5');
                                
                            }



                            //imageAspectRatio( $('.'+mediagach_vars.css+' .css-image-block').width(),  $('.'+mediagach_vars.css+' .css-image-block') );
                            //imageAspectRatio( $('.'+mediagach_vars.css+' .css-image-block').width(),  $('.'+mediagach_vars.css+' .css-image-block .offer-ajax-images') );

                            $(document).trigger('insert_inter');

                        },
                        error: function(xhr, status, error) {
                            //Ajax problem
                            console.log("101 error"+xhr+"--------"+status+"------"+error);
                            console.log(xhr);
                            console.log(xhr.responseText);
                            $("#ofertasLlistat .row-ofertas").append(xhr.responseText);
                            //getDetailOffer(id);
                        }
                    });
                }
                //Inicialitza l'objecte domFilters
                function domFilters() {
                    var obj = {};
                    var dom = document.querySelectorAll('#ofertasFiltre .filter');

                    for(var x = 0; x < dom.length; x++) {
                        var name = dom[x].getAttribute('id');
                        obj[name] = dom[x];
                    }

                    return obj;
                }

                function loadWaypointBottomOfertas(){
                    new Waypoint({
                        element: document.getElementById('bottom-ofertas'),
                        handler: function(direction) {
                            if(direction === 'down'){
                                //console.log("direction down");
                                startFilter = limitFilter;
                                limitFilter = limitFilter + 9;
                                listOffers();
                            } 
                        },
                        offset: '80%'
                    });
                }
                //String de les variables URL
                function buildURL(name, value) {
                    urlFilters[name] = value;
                    var url = '';

                    if(value == '' || value == null) delete urlFilters[name];

                    Object.keys(urlFilters).forEach(function(x, i){
                        var prefix = i === 0 ? '?' : '&';
                        url += prefix + x + '=' + urlFilters[x]; 
                    });

                    if(url == '') url = '?';

                    return url;
                }
                //Agafa variables de la URL i inicialitza si no estan;
                function getParamsFromURL(){

                    var params = window.location.href.split('?')[1];
                    if(params) {
                        params = params.split('&');

                        params.forEach(function(x){
                            var param = x.split('=');
                            urlFilters[param[0]] = decodeURI(param[1].replace('+','%20').replace('%2F','/').replace('%2B','%20'));
                        });
                    }

                    initFilters();
                }

                //buildCheckbox(),initChecked()
                function hardCodedModules() {

                    /* --- SortBy --- */
                    if(domFilters.sortBy) {
                        // Per defecte desde la URL

                        if(filters.sortBy) { 
                            var x = document.querySelector('[value=' + filters.sortBy + ']');
                            domFilters.sortBy.children[0].children[0].textContent = x ? x.textContent : mediagach_vars.lang.orderby;
                            domFilters.sortBy.children[0].children[0].style.color = '#000';
                            domFilters.sortBy.children[0].children[1].children[0].style.display = 'inline-block';
                        }
                    }
                    
                    /* --- Referencia --- */
                    if(domFilters.referencia) {
                        domFilters.referencia.children[0].value = filters.ref;
                    }

                    /* --- Range Select Min/Max --- */
                    ksa_rangePrice();

                    /* --- Habitacions --- */
                    if(domFilters.habitacions) {
                        // Per defecte desde la URL
                        if(filters.habitacions) {

                            var habs = mediagach_vars.lang.habitaciones;  
                            if(filters.habitacions == 1) habs = mediagach_vars.lang.habitacion;

                            domFilters.habitacions.children[0].children[0].textContent = filters.habitacions + ' ' + habs + ' ' + mediagach_vars.lang.omas;
                            domFilters.habitacions.children[0].children[0].style.color = '#000';
                            domFilters.habitacions.children[0].children[1].children[0].style.display = 'inline-block';
                        }
                    }

                    /* --- Superficie --- */
                    if(domFilters.superficie) {
                        // Per defecte desde la URL
                        if(filters.superficie) { 
                            domFilters.superficie.children[0].children[0].innerHTML = filters.superficie + ' m<sup>2</sup>';
                            domFilters.superficie.children[0].children[0].style.color = '#000';
                            domFilters.superficie.children[0].children[1].children[0].style.display = 'inline-block';
                        }
                    }
                    
                    /* --- Superficie Solar --- */
                    if(domFilters.superficie_solar) {
                        // Per defecte desde la URL
                        if(filters.superficie_solar) { 
                            domFilters.superficie_solar.children[0].children[0].innerHTML = filters.superficie_solar + ' m<sup>2</sup>';
                            domFilters.superficie_solar.children[0].children[0].style.color = '#000';
                            domFilters.superficie_solar.children[0].children[1].children[0].style.display = 'inline-block';
                        }
                    }

                    /* --- Places --- */
                    if(domFilters.places) {
                    // Per defecte desde la URL
                        if(filters.places) { 
                            domFilters.places.children[0].children[0].innerHTML = filters.places;
                            domFilters.places.children[0].children[0].style.color = '#000';
                            domFilters.places.children[0].children[1].children[0].style.display = 'inline-block';
                        }
                    }
                

                    ksa_buildCheckbox(mediagach_vars.lang.obra, 'obra', 'Piso, Apartamento, Dúplex, Ático, Edificio, Casa, Nave comercial, Nave industrial, Local comercial, Restaurante, Oficina');
                    ksa_buildCheckbox('Parking', 'parking', 'Piso, Apartamento, Dúplex, Ático, Edificio, Casa, Nave comercial, Nave industrial, Local comercial, Restaurante, Oficina');
                    ksa_buildCheckbox(mediagach_vars.lang.calefaccion, 'calefaccio', 'Piso, Apartamento, Dúplex, Ático, Edificio, Casa, Local comercial, Restaurante, Oficina');
                    ksa_buildCheckbox(mediagach_vars.lang.jardin, 'jardi', 'Piso, Apartamento, Dúplex, Ático, Edificio, Casa');
                    ksa_buildCheckbox(mediagach_vars.lang.terraza, 'terrasa', 'Piso, Apartamento, Dúplex, Ático, Edificio, Casa');
                    ksa_buildCheckbox('Piscina', 'piscina', 'Piso, Apartamento, Dúplex, Ático, Edificio, Casa');
                    ksa_buildCheckbox(mediagach_vars.lang.aire, 'aire', 'Piso, Apartamento, Dúplex, Ático, Edificio, Casa, Local comercial, Restaurante, Oficina');
                    ksa_buildCheckbox(mediagach_vars.lang.trastero, 'traster', 'Piso, Apartamento, Dúplex, Ático, Edificio, Casa');
                    ksa_buildCheckbox(mediagach_vars.lang.urbanizado, 'urbanitzat', 'Solar');
                    ksa_buildCheckbox(mediagach_vars.lang.muelle, 'moll', 'Nave comercial, Nave industrial');
                    ksa_buildCheckbox('Grúa', 'grua', 'Nave comercial, Nave industrial');
                    ksa_buildCheckbox('Aparador', 'aparador', 'Local comercial, Restaurante, Oficina');
                    ksa_buildCheckbox(mediagach_vars.lang.plantabaja, 'plb',  'Local comercial, Restaurante, Oficina');
                    ksa_buildCheckbox(mediagach_vars.lang.fotos, 'fotos', 'Piso, Apartamento, Dúplex, Ático, Edificio, Casa, Nave comercial, Nave industrial, Local comercial, Restaurante, Oficina, Solar');
                   
                }

                function ksa_rangePrice(){
      
                    function addPriceValue(x, parent, name){
                        //Evitar que el minim sigui mes gran que el maxim
                        if(name == 'minP' || !filters.minP || parseInt(filters.minP) <= x) {
                            var newOption = document.createElement('div');
                            newOption.setAttribute('value', x);
                            newOption.setAttribute('class', 'option');
                            newOption.textContent = x.toLocaleString() + ' €';
                            parent.children[1].appendChild(newOption);
                        }
                    }

                    function buildPriceSelect(domFilter, fromURL, name){
                        if(domFilter){

                            while (domFilter.children[1].firstChild) { domFilter.children[1].removeChild(domFilter.children[1].firstChild);} //Borrar antics    
    
                            if(!filters.operacio || filters.operacio == 'en alquiler') {
                                for(var min = 100; min < 1000; min += 100) {
                                    addPriceValue(min, domFilter, name);
                                }
    
                                for(var min = 1000; min <= 5000; min += 500) {
                                    addPriceValue(min, domFilter, name);
                                }
                            }
    
                            if(filters.operacio != 'en alquiler') {
                                addPriceValue(10000, domFilter, name);
    
                                for(var min = 20000; min <= 1000000; min += 20000) {
                                    addPriceValue(min, domFilter, name);
                                }
                                
                                for(var min = 1000000; min <= 7000000; min += 1000000) {
                                    addPriceValue(min, domFilter, name);
                                }
                            }
    
                            // Per defecte desde la URL
                            if(fromURL) { 
                                domFilter.children[0].children[0].textContent = parseInt(fromURL).toLocaleString() + '€';
                                domFilter.children[0].children[0].style.color = '#000';
                                domFilter.children[0].children[1].children[0].style.display = 'inline-block';
                            }
                        }
                    }

                    buildPriceSelect(domFilters.rangeMin, filters.minP, 'minP');
                    buildPriceSelect(domFilters.rangeMax, filters.maxP, 'maxP');

                }
                //Crea els filtres que depenen de la base de dades
                function processData() {
                    
                    /* --- Price Range --- */
                    if(domFilters.range) {
       
                        filters.minP = filters.minP == 0 ? infoFilters.minP : filters.minP;
                        filters.maxP = filters.maxP >= 1000000 ? 1000000 : filters.maxP;

                        var minim = parseInt(filters.minP);
    
                        //idconces retorna null
                        if(filters.minP && filters.maxP) {
                            var plus = filters.maxP == 1000000 ? ' +' : '';
                            domFilters.range.children[0].value = numberWithCommas(filters.minP) + ' € - ' + numberWithCommas(filters.maxP) + ' €' + plus;

                            $("#slider-range").slider({
                                range: true,
                                min: parseInt(filters.minP),
                                max: parseInt(filters.maxP),
                                step: 20000,
                                values: [filters.minP, filters.maxP],
                                slide: function(event, ui) {

                                    ui.values[1] = ui.values[1] == (1000000 - 20000 + minim) ? 1000000 : ui.values[1];

                                    var plus = ui.values[1] == 1000000 ? ' +' : '';
                                    domFilters.range.children[0].value = numberWithCommas(ui.values[0]) + ' € - ' + numberWithCommas(ui.values[1]) + ' €' + plus;
                                },
                                stop: function(event, ui) {
                                    filters.minP = ui.values[0] == infoFilters.minP ? '' : ui.values[0];
                                    filters.maxP = ui.values[1] == infoFilters.maxP ? '' : ui.values[1];

                                    filters.maxP = filters.maxP == (1000000 - 20000 + minim) ? 1000000 : filters.maxP;
        
                                    if(ui.value == ui.values[0]) {
                                        resetPagination('minP', filters.minP);
                                    } else {
                                        resetPagination('maxP', filters.maxP);
                                    }
        
                                }
                            });    

                        }
                    }

                    /* --- Provincias --- */
                    if(domFilters.provincia) {
                        ksa_buildSelect('provincia');
                    }

                    /* --- Municipis --- */
                    if(domFilters.municipi) {
                        ksa_buildSelect('municipi');
                    }

                    /* --- Address / Situacions --- */
                    if(domFilters.address) {
                        ksa_buildSelect('address');
                    }

                    /* --- Operacio --- */
                    if(domFilters.operacio) {
                        ksa_buildSelect('operacio', '_' + mediagach_vars.currentLang);
                        if(urlFilters.operacio) ksa_resetTypeFilters(urlFilters.operacio);
                    }

                    /* --- Tipus --- */
                    if(domFilters.immoble) {
                        ksa_buildSelect('immoble', '_' + mediagach_vars.currentLang);                        
                        if(urlFilters.immoble) ksa_resetTypeFilters(urlFilters.immoble);
                    }

                }

                function ksa_buildCheckbox(title, value, dataTypeFilter) {

                    var cbox = document.createElement('div');
                    var label = document.createElement('label');
                    var container = document.createElement('div');
                    var parent = document.querySelector('#allCboxs');
                    var checked = urlFilters[value] ? '1' : '0';

                    if(parent.getAttribute('allowed').indexOf(value) != -1) {
                        label.textContent = title;
                        cbox.setAttribute('checked', checked);
                        cbox.setAttribute('class', 'cbox');
                        cbox.setAttribute('value', value);
     
                        container.setAttribute('data-key', dataTypeFilter);
                        container.setAttribute('class','cbox-container col-xs-6 col-sm-6 col-md-6 col-lg-6');
                        container.appendChild(cbox);
                        container.appendChild(label);
                        parent.appendChild(container);
    
                        cbox.addEventListener('click', function() {
                            var checked = cbox.getAttribute('checked') == '1'; //Toggle
    
                            if(checked) {
                                cbox.setAttribute('checked', '0');
                                resetPagination(value, '');
                            } else {
                                cbox.setAttribute('checked', '1');
                                resetPagination(value, 1);
                            }
                        })
    
                    }
                }

                function ksa_buildSelect(selectName, lang) {

                    lang = lang ? lang : '';

                    var arr1Select = [];
                
                    if((selectName == 'municipi' || selectName == 'address') && urlFilters.provincia) {
                        // Filtrar els municipis d'una provincia
                        arr1Select = infoFilters.select.filter(function(x, i) {
                            return urlFilters.provincia == x.provincia;
                        })

                        // Filtrar les situacions d'un municipi
                        if(selectName == 'address' && typeof urlFilters.municipi != 'undefined') {
                            arr1Select = arr1Select.filter(function(x, i) {
                                return urlFilters.municipi == x.municipi;
                            })
                        }

                    } else {
                        arr1Select = infoFilters.select;
                    }
      
                    // Agafar nomes un
                    arr1Select = arr1Select.map(function(x) {
                        return x[selectName + lang];
                    });

                    var keys = infoFilters.select.map(function(x) {
                        return x['immoble_es'];
                    });

                    //Filtrar repetits
                    arr1Select = arr1Select.filter(function(x, i) {
                        return arr1Select.indexOf(x) == i;
                    });

                    keys = keys.filter(function(x, i) {
                        return keys.indexOf(x) == i;
                    });

                    var dom = domFilters[selectName].children; // span.default i div.options
                    
                    while (dom[1].firstChild) { dom[1].removeChild(dom[1].firstChild);} //Borrar antics

                    //Afegim les opcions BUSCADOR
                    //var option = document.createElement('input');
                    //option.setAttribute('type', 'text'); 
                    //option.setAttribute('keep','true');
                    //dom[1].appendChild(option);

                    for(var x = 0; x < arr1Select.length; x++){

                        var option = document.createElement('div');
                        option.setAttribute('value', arr1Select[x]); 
                        if(selectName == 'immoble')option.setAttribute('key', keys[x]);
                        option.setAttribute('class', 'option'); 
                        option.textContent = arr1Select[x];

                        // Per defecte desde la URL
                        if(filters[selectName] == arr1Select[x] && arr1Select[x].length > 0) { 
                            dom[0].children[0].textContent = arr1Select[x]; // Text visible
                            dom[0].children[0].style.color = '#000';
                            dom[0].children[1].children[0].style.display = 'inline-block';
                        }

                        dom[1].appendChild(option);
                    }
                    
                }

                function ksa_resetTypeFilters(key) {
                    var conditionalFilters = document.querySelectorAll('[data-key]');
                    conditionalFilters = Array.prototype.slice.call(conditionalFilters);

                    // Amagar tots
                    conditionalFilters.forEach(function(element) {
                        element.style.display = 'none';
                    });

                    // Filtrar els que volem mostrar
                    conditionalFilters = conditionalFilters.filter(function(el) {
                        var keys = el.getAttribute('data-key');
                        return keys.includes(key);
                    })
    
                    //Mostrar
                    conditionalFilters.forEach(function(element) {
                        element.style.display = 'flex';
                    });
                }

                //AJAX -> processData(), initListeners()
                function loadInfoForFilters(){
                    
                    $.ajax({
                        url: infoFilterURL,
                        type: "POST",
                        dataType: 'json',
                        data: { "p" : mediagach_vars,"filters" : filters,"urlFilters" : urlFilters},
                        success: function(data) {
                            infoFilters = data;                            
                            processData();
                            initListeners(); //Inicialitza tots els listeners dels filtres
                            jsForCss(); // Css per els estils dels filtres 
                        },
                        error: function(xhr, status, error) {
                            console.log("101 error"+xhr+"--------"+status+"------"+error);
                            console.log(xhr);
                            console.log(xhr.responseText);
                        }
                    });
                }

                function resetPagination(name, value) {

                    startFilter = 0;
                    limitFilter = 9;

                    window.scrollTo(0,0);

                    window.history.pushState(null, null, buildURL(name, value));
                    filters[name] = value;
                    
                    //Borrem totes les ofertas
                    while (ofertasLlistat.firstChild) {
                        ofertasLlistat.removeChild(ofertasLlistat.firstChild);
                    }

                    listOffers();

                }

                function initFilters() {
                    filters = {};
                    filters.minP = urlFilters.minP; // || 0;
                    filters.maxP = urlFilters.maxP; // || 1000000;
                    filters.sortBy = urlFilters.sortBy || '';
                    filters.provincia = urlFilters.provincia || '';
                    filters.municipi = urlFilters.municipi || '';
                    filters.address = urlFilters.address || '';
                    filters.operacio = urlFilters.operacio || '';
                    filters.immoble = urlFilters.immoble || '';
                    filters.ref = urlFilters.ref || '';
                    filters.parking = urlFilters.parking || '';
                    filters.calefaccio = urlFilters.calefaccio || '';
                    filters.jardi = urlFilters.jardi || '';
                    filters.terrasa = urlFilters.terrasa || '';
                    filters.piscina = urlFilters.piscina || '';
                    filters.traster = urlFilters.traster || '';
                    filters.obra = urlFilters.obra || '';
                    filters.habitacions = urlFilters.habitacions || '';
                    filters.superficie = urlFilters.superficie || '';
                    filters.superficie_solar = urlFilters.superficie_solar || '';
                    filters.urbanitzat = urlFilters.urbanitzat || '';
                    filters.moll = urlFilters.moll || '';
                    filters.aparador = urlFilters.aparador || '';
                    filters.grua = urlFilters.grua || '';
                    filters.plb = urlFilters.plb || '';
                    filters.sostre = urlFilters.sostre || '';
                    filters.fotos = urlFilters.fotos || '';
                    filters.places = urlFilters.places || '';
                }

                function initListeners(){

                    var inputs = document.querySelectorAll('.options input');
                    var defaults = document.querySelectorAll('.default');

                    // Select: toggle displays
                    for(var x = 0; x < defaults.length; x++) {
                        defaults[x].addEventListener('click', function() {

                            //Toggle Display block && none
                            var display = this.nextElementSibling.style.display; //.options
                            display = display == 'none' ? 'block' : 'none';

                            if(display == 'block') { 
                                var options = document.querySelectorAll('.options');
                                for(var i = 0; i < options.length; i++) options[i].style.display = 'none';
                            }
                            this.nextElementSibling.style.display = display;
                        });
                    }

                    document.body.addEventListener('click', function(ev) { 
                        if(!ev.target.getAttribute('keep')) {
                            for(var x = 0; x < defaults.length; x++) {
                                defaults[x].nextElementSibling.style.display = 'none';
                            }
                        }
                    })

                    // Select: Input Search
                    for(var x = 0; x < inputs.length; x++) {
                        inputs[x].addEventListener('input', function() {
                            var options = this.parentNode.children;
                            var regexp = new RegExp(this.value, 'i');

                            for(var i = 1; i < options.length; i++) {
                                if(regexp.test(options[i].getAttribute('value'))) {
                                    options[i].style.display = 'block';
                                } else {
                                    options[i].style.display = 'none';     
                                }
                            }

                        });
                    }
                    
                    if(btnBorrar) {
                        btnBorrar.addEventListener('click', function(){

                            startFilter = 0;
                            limitFilter = 9;

                            urlFilters = {};
        
                            window.scrollTo(0,0);
        
                            window.history.pushState(null, null, '?');
                            initFilters();
        
                            //Borrem totes les ofertas
                            while (ofertasLlistat.firstChild) {
                                ofertasLlistat.removeChild(ofertasLlistat.firstChild);
                            }

                            // Referencia input
                            domFilters.referencia.children[0].value = '';
        
                            listOffers();
                            // Toggle Checkbox
                            var cboxs = document.querySelectorAll('#ofertasFiltre .cbox');
                            cboxs = Array.prototype.slice.call(cboxs);

                            for(var x = 0; x < cboxs.length; x++) {
                                cboxs[x].parentNode.style.display = 'none';
                                cboxs[x].setAttribute('checked', '0');
                            }

                            //Selects Off
                            function clearSelect(field) {
                                if(field) {
                                    field.children[0].children[0].style.color = '#666';
                                    field.children[0].children[0].innerHTML = ' - '; 
                                    field.children[0].children[1].children[0].style.display = 'none'; // X
                                }
                            }

                            clearSelect(domFilters.rangeMin);
                            clearSelect(domFilters.rangeMax);
                            clearSelect(domFilters.sortBy);
                            clearSelect(domFilters.provincia);
                            clearSelect(domFilters.municipi);
                            clearSelect(domFilters.address);
                            clearSelect(domFilters.operacio);
                            clearSelect(domFilters.immoble); 
                            clearSelect(domFilters.habitacions);
                            clearSelect(domFilters.superficie);
                            clearSelect(domFilters.superficie_solar);
                            console.log(domFilters);   

                            //Slider Range
                            var min = $('#slider-range').slider( 'option', 'min');
                            var max = $('#slider-range').slider( 'option', 'max')
                            $('#slider-range').slider( 'option', 'values', [ min, max] );
                            domFilters.range.children[0].value = numberWithCommas(min) + ' € - ' + numberWithCommas(max) + ' € +';

                        })
                    }

                    if(domFilters.sortBy) {
                        domFilters.sortBy.addEventListener('click', function(ev) {

                            var value = ev.target.getAttribute('value');

                            if(typeof(value) == 'string') {
                                
                                this.children[0].children[0].textContent = ev.target.textContent;
                                this.children[0].children[0].style.color = '#000';
                                this.children[0].children[1].children[0].style.display = 'inline-block';
                                resetPagination('sortBy', value);
                            };

                            if(ev.target.classList.contains('remove-option')) {

                                this.children[0].children[0].textContent = ' - ';
                                this.children[0].children[0].style.color = '#666';
                                this.children[0].children[1].children[0].style.display = 'none';
                                resetPagination('sortBy', value);
                            }

                        })
                    }


                    if(domFilters.rangeMin) {

                        domFilters.rangeMin.addEventListener('click', function(ev) { 
                            var value = ev.target.getAttribute('value');

                            if(typeof(value) == 'string') {          
                                this.children[0].children[0].textContent = parseInt(value).toLocaleString() + ' €';
                                this.children[0].children[0].style.color = '#000';
                                this.children[0].children[1].children[0].style.display = 'inline-block';

                                // Al canviar min reset max si min es mes gran
                                if(domFilters.rangeMax && parseInt(value) > parseInt(filters.maxP)) {
                       
                                    delete urlFilters.maxP; 
                                    window.history.pushState(null, null, buildURL('maxP',''));

                                    domFilters.rangeMax.children[0].children[0].style.color = '#666';
                                    domFilters.rangeMax.children[0].children[0].textContent = ' Max ';
                                    domFilters.rangeMax.children[0].children[1].children[0].style.display = 'none'; // x button

                                    filters.maxP = '';
                                }

                                resetPagination('minP', value);
                                ksa_rangePrice();
                            }


                            if(ev.target.classList.contains('remove-option')) {

                                this.children[0].children[0].textContent = ' Min ';
                                this.children[0].children[0].style.color = '#666';
                                this.children[0].children[1].children[0].style.display = 'none';
                                
                                resetPagination('minP', value);
                                ksa_rangePrice();
                            }
                        })
                    }

                    if(domFilters.rangeMax) {

                        domFilters.rangeMax.addEventListener('click', function(ev) { 
                            var value = ev.target.getAttribute('value');

                            if(typeof(value) == 'string') {          
                                this.children[0].children[0].textContent = parseInt(value).toLocaleString() + ' €';
                                this.children[0].children[0].style.color = '#000';
                                this.children[0].children[1].children[0].style.display = 'inline-block';
                                resetPagination('maxP', value);
                            }

                            if(ev.target.classList.contains('remove-option')) {

                                this.children[0].children[0].textContent = ' Max ';
                                this.children[0].children[0].style.color = '#666';
                                this.children[0].children[1].children[0].style.display = 'none';
                                resetPagination('maxP', value);
                            }
                        })
                    }

                    if(domFilters.provincia) {

                        domFilters.provincia.addEventListener('click', function(ev) {

                            var value = ev.target.getAttribute('value');

                            if(typeof(value) == 'string') {
                                
                                this.children[0].children[0].textContent = value;
                                this.children[0].children[0].style.color = '#000';
                                this.children[0].children[1].children[0].style.display = 'inline-block';

                                // Al canviar provincia reset municipis
                                if(domFilters.municipi) {
                                    delete urlFilters.municipi; 
                                    window.history.pushState(null, null, buildURL('municipi',''));

                                    domFilters.municipi.children[0].children[0].style.color = '#666';
                                    domFilters.municipi.children[0].children[0].textContent = ' - ';
                                    domFilters.municipi.children[0].children[1].children[0].style.display = 'none'; // x button

                                    filters.municipi = '';
                                }

                                // Al canviar provincia reset address
                                if(domFilters.address) {
                                    delete urlFilters.address; 
                                    window.history.pushState(null, null, buildURL('address',''));

                                    domFilters.address.children[0].children[0].style.color = '#666';
                                    domFilters.address.children[0].children[0].textContent = ' - ';
                                    domFilters.address.children[0].children[1].children[0].style.display = 'none'; // x button

                                    filters.address = '';
                                }

                                resetPagination('provincia', value);
                                ksa_buildSelect('municipi');
                                ksa_buildSelect('address');

                            }

                            if(ev.target.classList.contains('remove-option')) {

                                this.children[0].children[0].textContent = ' - ';
                                this.children[0].children[0].style.color = '#666';
                                this.children[0].children[1].children[0].style.display = 'none';

                                // Al canviar provincia reset municipis
                                if(domFilters.municipi) {
                                    delete urlFilters.municipi; 
                                    window.history.pushState(null, null, buildURL('municipi',''));

                                    domFilters.municipi.children[0].children[0].style.color = '#666';
                                    domFilters.municipi.children[0].children[0].textContent = ' - ';
                                    domFilters.municipi.children[0].children[1].children[0].style.display = 'none'; // x button

                                    filters.municipi = '';
                                }

                                // Al canviar provincia reset address
                                if(domFilters.address) {
                                    delete urlFilters.address; 
                                    window.history.pushState(null, null, buildURL('address',''));

                                    domFilters.address.children[0].children[0].style.color = '#666';
                                    domFilters.address.children[0].children[0].textContent = ' - ';
                                    domFilters.address.children[0].children[1].children[0].style.display = 'none'; // x button

                                    filters.address = '';
                                }

                                resetPagination('provincia', value);
                                ksa_buildSelect('municipi');
                                ksa_buildSelect('address');
                            }


                        })
                    }

                    if(domFilters.municipi) {

                        domFilters.municipi.addEventListener('click', function(ev) {

                            var value = ev.target.getAttribute('value');

                            if(typeof(value) == 'string') {
                                
                                this.children[0].children[0].textContent = value;
                                this.children[0].children[0].style.color = '#000';
                                this.children[0].children[1].children[0].style.display = 'inline-block';

                                // Al canviar municipi reset address
                                if(domFilters.address) {
                                    delete urlFilters.address; 
                                    window.history.pushState(null, null, buildURL('address',''));

                                    domFilters.address.children[0].children[0].style.color = '#666';
                                    domFilters.address.children[0].children[0].textContent = ' - ';
                                    domFilters.address.children[0].children[1].children[0].style.display = 'none'; // x button

                                    filters.address = '';
                                }

                                ksa_buildSelect('address');
                                resetPagination('municipi', value);
                            }

                            if(ev.target.classList.contains('remove-option')) {

                                this.children[0].children[0].textContent = ' - ';
                                this.children[0].children[0].style.color = '#666';
                                this.children[0].children[1].children[0].style.display = 'none';

                                // Al canviar municipi reset address
                                if(domFilters.address) {
                                    delete urlFilters.address; 
                                    window.history.pushState(null, null, buildURL('address',''));

                                    domFilters.address.children[0].children[0].style.color = '#666';
                                    domFilters.address.children[0].children[0].textContent = ' - ';
                                    domFilters.address.children[0].children[1].children[0].style.display = 'none'; // x button

                                    filters.address = '';
                                }

                                ksa_buildSelect('address');
                                resetPagination('municipi', value);
                            }

                        })
                    }

                    if(domFilters.address) {

                        domFilters.address.addEventListener('click', function(ev) {

                            var value = ev.target.getAttribute('value');

                            if(typeof(value) == 'string') {
                                
                                this.children[0].children[0].textContent = value;
                                this.children[0].children[0].style.color = '#000';
                                this.children[0].children[1].children[0].style.display = 'inline-block';
                                resetPagination('address', value);
                            };

                            if(ev.target.classList.contains('remove-option')) {

                                this.children[0].children[0].textContent = ' - ';
                                this.children[0].children[0].style.color = '#666';
                                this.children[0].children[1].children[0].style.display = 'none';
                                resetPagination('address', value);
                            }

                        })
                    }

                    if(domFilters.referencia) {
                        domFilters.referencia.addEventListener('input', function(ev) {
                            var ref = this.children[0].value;
                            resetPagination('ref', ref);
                        })
                    }

                    if(domFilters.operacio) {
                        domFilters.operacio.addEventListener('click', function(ev) {

                            var value = ev.target.getAttribute('value');

                            if(typeof(value) == 'string') {
                                
                                this.children[0].children[0].textContent = value;
                                this.children[0].children[0].style.color = '#000';
                                this.children[0].children[1].children[0].style.display = 'inline-block';
                                resetPagination('operacio', value);
                                ksa_rangePrice();
                            };

                            if(ev.target.classList.contains('remove-option')) {

                                this.children[0].children[0].textContent = ' - ';
                                this.children[0].children[0].style.color = '#666';
                                this.children[0].children[1].children[0].style.display = 'none';
                                resetPagination('operacio', value);
                                ksa_rangePrice();
                            }

                        })
                    }

                    if(domFilters.immoble) {
                        domFilters.immoble.addEventListener('click', function(ev) {

                            var value = ev.target.getAttribute('value');

                            if(typeof(value) == 'string') {
                                
                                this.children[0].children[0].textContent = value;
                                this.children[0].children[0].style.color = '#000';
                                this.children[0].children[1].children[0].style.display = 'inline-block';
                                resetPagination('immoble', value);
                                ksa_resetTypeFilters(ev.target.getAttribute('key'));
                            };

                            if(ev.target.classList.contains('remove-option')) {

                                this.children[0].children[0].textContent = ' - ';
                                this.children[0].children[0].style.color = '#666';
                                this.children[0].children[1].children[0].style.display = 'none';
                                resetPagination('immoble', value);
                                ksa_resetTypeFilters(ev.target.getAttribute('key'));
                            }

                        })
                    }

                    if(domFilters.habitacions) {

                        domFilters.habitacions.addEventListener('click', function(ev) {     
                            var value = ev.target.getAttribute('value');

                            if(typeof(value) == 'string') {

                                var habs = mediagach_vars.lang.habitaciones;  
                                if(value == 1) habs = mediagach_vars.lang.habitacion;
                                                                
                                this.children[0].children[0].textContent = value + ' ' + habs + ' ' + mediagach_vars.lang.omas;
                                this.children[0].children[0].style.color = '#000';
                                this.children[0].children[1].children[0].style.display = 'inline-block';
                                resetPagination('habitacions', value);
                            }


                            if(ev.target.classList.contains('remove-option')) {

                                this.children[0].children[0].textContent = ' - ';
                                this.children[0].children[0].style.color = '#666';
                                this.children[0].children[1].children[0].style.display = 'none';
                                resetPagination('habitacions', value);
                            }
                        })
                    }

                    if(domFilters.superficie) {

                        domFilters.superficie.addEventListener('click', function(ev) {     
                            var value = ev.target.getAttribute('value');

                            if(typeof(value) == 'string') {
                                                                
                                this.children[0].children[0].innerHTML = value + ' m<sup>2</sup>';
                                this.children[0].children[0].style.color = '#000';
                                this.children[0].children[1].children[0].style.display = 'inline-block';
                                resetPagination('superficie', value);
                            }

                            if(ev.target.classList.contains('remove-option')) {

                                this.children[0].children[0].textContent = ' - ';
                                this.children[0].children[0].style.color = '#666';
                                this.children[0].children[1].children[0].style.display = 'none';
                                resetPagination('superficie', value);
                            }
                        })
                    }

                    if(domFilters.superficie_solar) {

                        domFilters.superficie_solar.addEventListener('click', function(ev) {     
                            var value = ev.target.getAttribute('value');

                            if(typeof(value) == 'string') {
                                                                
                                this.children[0].children[0].innerHTML = value + ' m<sup>2</sup>';
                                this.children[0].children[0].style.color = '#000';
                                this.children[0].children[1].children[0].style.display = 'inline-block';
                                resetPagination('superficie_solar', value);
                            }


                            if(ev.target.classList.contains('remove-option')) {

                                this.children[0].children[0].textContent = ' - ';
                                this.children[0].children[0].style.color = '#666';
                                this.children[0].children[1].children[0].style.display = 'none';
                                resetPagination('superficie_solar', value);
                            }
                        })
                    }

                    if(domFilters.places) {

                        domFilters.places.addEventListener('click', function(ev) {     
                            var value = ev.target.getAttribute('value');

                            if(typeof(value) == 'string') {
                                                                
                                this.children[0].children[0].textContent = value;
                                this.children[0].children[0].style.color = '#000';
                                this.children[0].children[1].children[0].style.display = 'inline-block';
                                resetPagination('places', value);
                            }


                            if(ev.target.classList.contains('remove-option')) {

                                this.children[0].children[0].textContent = ' - ';
                                this.children[0].children[0].style.color = '#666';
                                this.children[0].children[1].children[0].style.display = 'none';
                                resetPagination('places', value);
                            }
                        })
                    }

                    // ksa_buildCheckbox () conté listeners;

                    loadWaypointBottomOfertas(); // Listener per carregar noves ofertes 
                }
                //Silvia
                function initModalForm() {
                    
                    var offersSelected = [];
                    var offersSelectedPrivado = [];

                    function fillTextarea(t) {
                        offersSelected.push(t.data('info-oferta'));
                        texto = "Hola!\nQuiero recibir más información de:\n";
                        $.each(offersSelected, function(key, value) {
                            texto = texto + "\n" + value + ".";
                        });
                        texto = texto + "\n\n¡Gracias!";
                        $(".modal-offer-related textarea").html(texto);
                    }
    
                    function fillHiddenField(t) {
                        offersSelectedPrivado.push(t.data('info-hidden'));
                        texto2 = "";
                        $.each(offersSelectedPrivado, function(key, value) {
                            texto2 = texto2 + "\n" + value + ".";
                        });
                        $(".modal-offer-related .textarea-privado textarea").html(texto2);
                    }

                    

                    $("body").on("click",".addMessage",function(){
                        $(".textarea-interested").toggleClass("hidden");
                        $(".addMessage p").toggleClass("hidden");
                    });

                    
                    $("body").on("click",".pideOferta",function(){

                        mgUtils.trackMetaDataStorage('utils', 'idOferta', '', '', $(this).attr('data-id-item'));

                        //Silvia
                        if($(this).data("adw-item")){
                            $(".adw-content").attr("data-adw-item",$(this).data("adw-item"));
                            $(".adw-content").attr("data-adw-item2",$(this).data("adw-item2"));
                            $(".adw-content").attr("data-adw-totalvalue",$(this).data("adw-totalvalue"));
                        }

                        mgUtils.googleAdwordsCodes();
    
                        var copiedModal = $("#modal-pideOferta");
                        $("#modal-pideOferta").remove();
                        copiedModal.appendTo("body");
                        $("#modal-pideOferta").modal();
                        fillTextarea($(this));
                        fillHiddenField($(this));
                        $(".textarea-interested").addClass("hidden");
                        $(".addMessage p").removeClass("hidden");

                        //Silvia
                        ga('send', 'event', 'Solicitar Oferta', 'Listado Ofertas', $(this).attr("data-info-oferta"));
                        
                    });
    
                    $("body").on("click",".btn-open-form-detail",function(){
                        copiedModal = $("#modal-pideOferta");
                        $("#modal-pideOferta").remove();
                        copiedModal.appendTo("body");
                        $("#modal-pideOferta").modal();
                        fillTextarea($(this));
                        fillHiddenField($(this));
                        $(".textarea-interested").addClass("hidden");
                        $(".addMessage p").removeClass("hidden");
                    });

                }

                function jsForCss(){
                
                    //Filter Fixed
                    new Waypoint({
                        element: $(".navbar"),
                        handler: function(direction) {
                            if(direction === 'down'){
                                $("#ofertasFiltre").addClass("stuck");
                                //console.log('entra!!!');
                            }else{
                                $("#ofertasFiltre").removeClass("stuck");
                            }
                        },
                        offset: -70
                    })

                    //Filter Toggle Left
                    var open = document.querySelector('.open-filters');

                    open.addEventListener('click', function() {
                        var ofertasFiltre = document.querySelector('#ofertasFiltre');

                        if(ofertasFiltre.classList.contains('moveFilter')) {
                            ofertasFiltre.classList.remove('moveFilter');
                        } else {
                            ofertasFiltre.classList.add('moveFilter');
                        }

                    })

                    var aplicarf = document.querySelector('#aplicarFiltres');

                    if(aplicarf) {
                        aplicarf.addEventListener('click', function() {
                            $('.open-filters').trigger('click');
                        })
    
                    }
                    
                }

                getParamsFromURL(); //Agafa els parametres de la URL i inicialitza filtres(var)
                listOffers(); // Carrega les ofertes per AJAX
                hardCodedModules(); //Moduls construits al HTML
                loadInfoForFilters(); // Query AJAX amb la info dels filtres
                initModalForm(); //Modal Form

                $(window).on('resize', function(){ 
                    //imageAspectRatio( $('.'+mediagach_vars.css+' .css-image-block').width(),  $('.'+mediagach_vars.css+' .css-image-block') );
                    //imageAspectRatio( $('.'+mediagach_vars.css+' .css-image-block').width(),  $('.'+mediagach_vars.css+' .css-image-block .offer-ajax-images') );                           
                });                
            }
        },
        'page_template_template_obra_nueva': {
            init: function() {

            },
            finalize: function() {
                
                $('.offer-images').owlCarousel({
                    items: 1,
                    //autoplay: true,
                    dots: false,
                    nav: true, 
                    loop: true,
                    mouseDrag: false,
                    touchDrag: true,
                    pullDrag: false,
                    rewind: false,
                    lazyLoad: true,
                    transitionStyle : 'fade',
                    navText: [
                        '<object><a href="#" onclick="return false;"><i class="icon-mediagach-navigation-chevron-left"></i></a></object>',
                        '<object><a href="#" onclick="return false;"><i class="icon-mediagach-navigation-chevron-right"></i></a></object>'
                    ],
                    onInitialize: function(event) {

                        var item_count = this.$element[0].getAttribute('nImages');
          
                        // Check if only one slide in carousel
                        if (item_count <= 1) {
                            this.options.nav = false;
                            this.options.navText = '';
                        }

                    }
                });

                $('.obra-nueva-open-modal').click(function() {
                    var obraTitle = $(this).attr('data-obra-title');
                    var input = document.querySelector('.obra-nueva-hidden-field input');
                    input.setAttribute('value', obraTitle);
                })

                /*new Waypoint({
                    element: $(".offer-detail-container-form"),
                    handler: function(direction) {
                      if(direction === "down"){
                        $(".offer-detail-container-form").addClass("stuck");
                      }else{
                        $(".offer-detail-container-form").removeClass("stuck");
                      }
                    },
                    offset: 25
                })*/

            }
        },
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });
 
            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
